export const en = {
  'language.switchTo': 'Switch to {language}',
  'language.english': 'English',
  'language.hebrew': 'Hebrew',
  'language.pickerLabel': 'Language',
  'language.toggleShortcutHint': 'Switch language (Alt+Shift+L)',

  'common.back': '← Back',
  'common.clear': 'Clear',
  'common.showFullDetails': 'Show full details',
  'common.hideFullDetails': 'Hide full details',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.update': 'Update',
  'common.display': 'Display',
  'common.fetch': 'Fetch',
  'common.create': 'Create',
  'common.submit': 'Submit',
  'common.submitting': 'Submitting…',
  'common.loading': 'Loading…',

  'splash.tagline': 'ONE APP. ANY SPACE.',
  'splash.brandAlt': 'Placy — One app. Any space.',
  'splash.progress': '{percent}% ..worth the wait',

  'common.guest': 'Guest',
  'common.comingSoon': '(coming soon)',
  'common.required': 'Required',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.operation': 'Operation',
  'common.month': 'Month',
  'common.day': 'Day',
  'common.year': 'Year',
  'common.qty': 'Qty',
  'common.moreInfo': 'More information',
  'common.thingsToCheck': 'Things to check',
  'common.request': 'Request:',
  'common.message': 'Message:',
  'common.emptyAll': 'Empty all fields, clear the response, and remove errors',
  'common.resetPanel': 'Reset fields and clear response',
  'common.signInRequired': 'Sign in required',
  'common.somethingWrong': 'Something went wrong.',
  'common.technicalDetails': 'Technical details',
  'common.showFields': 'Show fields',
  'common.hideFields': 'Hide fields',
  'common.showInputFields': 'Show input fields',
  'common.hideInputFields': 'Hide input fields',
  'common.clearIdentifierPassword': 'Clear identifier and password',
  'common.rawJson': 'Raw JSON',

  'nav.main': 'Main',
  'nav.home': 'Home',
  'nav.bookings': 'Bookings',
  'nav.assets': 'Assets',
  'nav.favorites': 'Favorites',
  'nav.messages': 'Messages',
  'nav.messagesUnread': 'Messages, {count} unread',
  'nav.profile': 'Profile',
  'nav.contact': 'Contact us',
  'nav.download': 'Get the app',
  'nav.downloadClose': 'Close install options',
  'nav.installTitle': 'Add to your home screen',
  'nav.installNow': 'Install app',
  'nav.installDone': 'The app is already on your home screen.',
  'nav.installIosStep1': 'Open this site in Safari.',
  'nav.installIosStep2': 'Tap the Share button.',
  'nav.installIosStep3': 'Choose “Add to Home Screen”.',
  'nav.installAndroidStep1': 'Open the browser menu (⋮).',
  'nav.installAndroidStep2': 'Choose “Install app” or “Add to Home screen”.',
  'nav.installDesktopHint':
    'Open this site in your phone’s browser to add it to the home screen.',
  'nav.advertiseSoon': 'Advertise (coming soon)',
  'nav.leavePayment': 'Leave payment? Your booking will not be completed.',

  'messages.title': 'Messages',
  'messages.loading': 'Loading conversations…',
  'messages.empty': 'No conversations yet. When someone messages you, it will show up here.',
  'messages.loadFailed': 'Could not load conversations.',
  'messages.unknownPeer': 'User',
  'messages.noMessagesYet': 'No messages yet',
  'messages.unreadCount': '{count} unread',
  'messages.backToInbox': 'Back to inbox',
  'messages.loadingThread': 'Loading messages…',
  'messages.threadLoadFailed': 'Could not load messages.',
  'messages.composerPlaceholder': 'Type a message…',
  'messages.send': 'Send',
  'messages.sendFailed': 'Could not send message.',
  'messages.startFailed': 'Could not start conversation.',
  'messages.new': 'New message',
  'messages.newTitle': 'New message',
  'messages.newHint': 'Pick someone, write a message, then send.',
  'messages.pickRecipient': 'To',
  'messages.searchPeople': 'Search people…',
  'messages.noContacts': 'No people to message yet. Open stories to discover people first.',
  'messages.messagingWith': 'Messaging {name}',
  'messages.unreadSection': 'New messages',
  'messages.earlierSection': 'Earlier',

  'header.searchSoon': 'Search (coming soon)',
  'header.searchTitle': 'Search assets',
  'header.searchLabel': 'Keyword',
  'header.searchPlaceholder': 'Name, address, or description…',
  'header.searchPrompt': 'Type a name, address, or description to find assets.',
  'header.searchMinLength': 'Type at least 3 characters to search.',
  'header.searchLoading': 'Loading assets…',
  'header.searchNoResults': 'No assets match that keyword.',
  'header.searchSubmit': 'Search',
  'assistant.fab.label': 'Open voice assistant',
  'assistant.panel.title': 'Placy assistant',
  'assistant.panel.close': 'Close assistant',
  'assistant.panel.empty': 'Say or type a command to get started.',
  'assistant.panel.inputLabel': 'Assistant command',
  'assistant.panel.send': 'Send',
  'assistant.panel.newSearch': 'New search',
  'assistant.panel.clear': 'Clear',
  'assistant.panel.thinking': 'Thinking…',
  'assistant.panel.speakOn': 'Turn on spoken replies',
  'assistant.panel.speakOff': 'Turn off spoken replies',
  'assistant.panel.speakUnsupported': 'Spoken replies are not available on this device.',
  'assistant.voice.start': 'Start voice search',
  'assistant.voice.stop': 'Stop listening',
  'assistant.voice.listening': 'Listening…',
  'assistant.voice.hint': 'Tap the mic and speak (up to 8 seconds). You can edit the keyword after.',
  'assistant.voice.editable': 'You can edit the keyword before results update.',
  'assistant.voice.greeting': 'How can I help you, {name}?',
  'assistant.voice.greetingAnonymous': 'How can I help you?',
  'assistant.voice.typeOpenSpace': 'open-space desks',
  'assistant.voice.actionSearchTypeCity': 'Searching {type} in {city} for you',
  'assistant.voice.actionSearchType': 'Searching {type} for you',
  'assistant.voice.actionSearchCity': 'Searching listings in {city} for you',
  'assistant.voice.actionSearch': 'Searching “{q}” for you',
  'assistant.voice.actionSearchTypeSlot': 'Searching {type} for you. {chip}',
  'assistant.voice.actionSearchSlot': 'Searching for you. {chip}',
  'assistant.voice.actionRefine': 'Narrowing the results for you',
  'assistant.voice.unsupported':
    'Voice input is not available on this device. Make sure Google voice typing (Speech Services by Google) is installed and enabled, or type your search.',
  'assistant.voice.denied':
    'Microphone access was denied. Allow the microphone when Placy asks, then try again.',
  'assistant.voice.empty': 'Didn’t catch that. Try again or type your search.',
  'assistant.voice.error': 'Voice error: {code}',
  'assistant.result.search': 'Searching for “{q}”.',
  'assistant.result.searchTypeCity': 'Searching {type} in {city}…',
  'assistant.result.searchType': 'Searching {type}…',
  'assistant.result.searchCity': 'Searching in {city}…',
  'assistant.result.browseType': 'Opening {type} listings.',
  'assistant.result.searchSlot': '{chip}',
  'assistant.result.searchTypeSlot': 'Searching {type}. {chip}',
  'assistant.result.refine': 'Narrowing the current results. {chip}',
  'assistant.result.noMatch': 'No listings matched that search.',
  'assistant.result.foundCount': 'Found {count} assets.',
  'assistant.result.foundCountOne': 'Found 1 asset.',
  'assistant.result.cheapest': 'The cheapest is {name} — {price}. The results are sorted from cheapest to most expensive.',
  'assistant.result.mostExpensive':
    'The most expensive is {name} — {price}. The results are sorted from most expensive to cheapest.',
  'assistant.result.priceSortNoPrice': 'I sorted the results by price, but none of them lists a price.',
  'assistant.result.closestToStreet':
    'The closest to {street} is {name} — {distance}. The results are sorted by distance to that street.',
  'assistant.result.proximityNoGeo':
    'I could not place that street on the map, so I left the results unsorted by distance.',
  'assistant.slot.chipAria': 'Requested time and place: {chip}',
  'assistant.result.navigate': 'Opening {target}.',
  'assistant.result.clearFavorites': 'Removed {count} favorites.',
  'assistant.result.clearFavoritesEmpty': 'You have no favorites to remove.',
  'assistant.result.favoritesSearchEmpty':
    'You have no saved favorites yet. Tap the heart on a listing to save it, then try again.',
  'assistant.result.bookConfirmPrompt':
    'Ready to open booking for {q}. Confirm to continue — nothing is charged yet.',
  'assistant.result.bookOpened': 'Opening booking. Review dates and pay only after you confirm in the booking screen.',
  'assistant.result.bookSearchFirst': 'Searching for “{q}” so you can pick an asset, then book.',
  'assistant.result.bookCancelled': 'Booking cancelled.',
  'assistant.book.currentAsset': 'this asset',
  'assistant.book.confirmAria': 'Confirm booking assistance',
  'assistant.book.confirmText': 'Open the booking screen with a draft? You still confirm payment yourself.',
  'assistant.book.confirm': 'Yes, open booking',
  'assistant.book.cancel': 'Cancel',
  'assistant.error.unknown': 'I did not understand that query. Try a search, navigation, or help question.',
  'assistant.error.bookNeedsConfirm': 'Booking requires an on-screen confirmation.',
  'assistant.error.bookNeedsLogin': 'Sign in to continue with booking.',
  'assistant.error.bookNoAsset': 'Open an asset first, or say “book” with a name to search.',
  'assistant.clarify.citySuggestions':
    'I heard “{heard}”. Did you mean {options}? Say the city name to continue.',
  'assistant.clarify.streetOrCity':
    'I heard “{heard}”. Is that a city or a street? If it’s a city, try {options}.',
  'assistant.faq.businessLounge':
    'A business lounge is a flexible workspace for meetings and light work — filter by Business Lounge in browse or search “business lounge”.',
  'assistant.faq.becomeOwner':
    'To list spaces, register as an asset owner from the login portal, then use Assets to create listings with photos, pricing, and opening hours.',
  'assistant.faq.howBookingWorks':
    'Pick an asset, choose dates and a pricing period, then confirm and pay in the booking flow. The assistant never pays for you.',
  'assistant.faq.voiceHelp':
    'You can search (“gym in Tel Aviv”), browse a type (“conference room”), navigate (“go to favorites”), clear all favorites (“delete all my favorites”), ask FAQ questions, or say “book this” after opening an asset — booking always needs your confirm. Tap the speaker icon to hear replies aloud.',
  'header.lastErrorInspect': 'View last error',
  'header.lastErrorTitle': 'Last error',
  'header.lastErrorEmpty': 'No errors recorded yet.',
  'header.lastErrorWhen': 'When',
  'header.lastErrorSource': 'Source',
  'header.lastErrorCode': 'Error code',
  'header.lastErrorDescription': 'Description',
  'header.lastErrorNetwork': 'Network',
  'header.lastErrorContextJson': 'Request context (JSON)',
  'header.lastErrorResponseJson': 'API response (JSON)',
  'header.lastErrorClear': 'Clear error',
  'header.notificationsTest': 'Notifications — connection test',
  'header.notificationsTitle': 'Notifications',
  'header.notificationsSubtitle': 'Bookings starting in the next 24 hours',
  'header.notificationsLoading': 'Loading bookings…',
  'header.notificationsEmpty': 'There are no new notifications.',
  'header.notificationsSignIn': 'Sign in to see upcoming booking reminders.',
  'header.notificationsViewAll': 'View all bookings',
  'header.signIn': 'Sign in',
  'header.register': 'Register',
  'header.greeting': 'Hi, {name}',
  'header.logOut': 'Log out',
  'header.guest': 'Guest',
  'desktopBanner.navLabel': 'Browse categories',
  'desktopBanner.searchPlaceholder': 'What would you like to book today?',
  'desktopBanner.uploadProperty': 'List a space',

  'home.allTypes': 'All types',
  'home.mostPopular': 'Popular assets',
  'home.recommended': 'Recommended in your area',
  'home.officesNearby': 'In your vicinity',
  'home.gymsNearby': 'Gyms in your vicinity',
  'home.noGymsNearby': 'No gyms nearby to show yet.',
  'home.frequentlyBooked': 'Frequently booked',
  'home.recentlyViewed': 'Recently viewed',
  'home.noRecentlyViewed': 'Spaces you open will appear here.',
  'home.promoAds': 'Featured',
  'home.promoAdsPrev': 'Previous featured items',
  'home.promoAdsNext': 'Next featured items',
  'home.promoAd.offizzLogo': 'Placy',
  'home.promoAd.billboard': 'Outdoor advertising',
  'home.promoAd.dynamicOffice': 'Flexible office space with Placy',
  'home.promoAd.registerDiscount': 'Register now and enjoy 10% off with Placy',
  'home.promoAd.referFriend': 'Refer a friend — you get 10% credit and they get 10% off',
  'home.promoAd.appLocations': '3 locations, one day — everything in one app',
  'home.promoAd.flexibleOffice': 'The right office for the right moment',
  'home.promoAd.appDiscover': 'Discover everything in the Placy app',
  'home.showAll': 'Show all',

  'favorites.title': 'Favorites',
  'favorites.loading': 'Loading your favorites…',
  'favorites.empty': 'No favorite spaces yet. Tap the heart on a space to save it here.',
  'favorites.add': 'Add {title} to favorites',
  'favorites.remove': 'Remove {title} from favorites',
  'favorites.backToList': '← Back to favorites',
  'favorites.removeFromList': 'Remove {title} from favorites',
  'favorites.removeFromListShort': 'Remove',
  'home.loadingSpaces': 'Loading spaces…',
  'home.loadSpacesError': 'Could not load spaces. Try again later.',
  'home.noSpaces': 'No spaces to show yet.',
  'home.browseAsset': 'Browse {title}',
  'home.carouselPrev': 'Previous {section}',
  'home.carouselNext': 'Next {section}',
  'home.browseByAssetType': 'Browse by asset type',
  'home.searchCategoriesTitle': 'What would you like to search for?',
  'home.bookingCategoriesTitle': 'What are we booking today?',
  'home.categoryFlipCta.privateOffice': 'All private offices',
  'home.categoryFlipCta.openSpace': 'All Open Space venues',
  'home.categoryFlipCta.conferenceRoom': 'All meeting rooms',
  'home.categoryFlipCta.gym': 'All gyms',
  'home.categoryFlipCta.parking': 'All parking',
  'home.categoryFlipCta.podcastStudio': 'All podcast studios',
  'home.categoryFlipCta.lectureRoom': 'All lecture halls',
  'home.categoryFlipCta.clinic': 'All treatment rooms',
  'home.categoryFlipCta.businessLounge': 'All lounges',
  'home.categoryFlipCta.classroom': 'All classrooms',
  'home.categoryFlipCta.workshop': 'All workshops',
  'home.searchCategoriesSeeMore': 'See more',
  'home.prevAssetTypes': 'Previous asset types',
  'home.nextAssetTypes': 'Next asset types',
  'home.assetSubTitleNew': 'New on the market',
  'home.assetSubTitlePrime': 'Prime location',
  'home.partnerLogos': 'Partner brands',
  'home.partnerLogosPrev': 'Previous partner logos',
  'home.partnerLogosNext': 'Next partner logos',

  'assetType.parking': 'Parking',
  'assetType.meeting': 'Meeting room',
  'assetType.openSpace': 'Open space',
  'assetType.office': 'Office',

  'social.featuredProfiles': 'Featured profiles',
  'social.prevProfiles': 'Previous profiles',
  'social.nextProfiles': 'Next profiles',
  'social.yourProfile': 'You',
  'social.addPost': 'Add a story',
  'social.postCount': '{count} stories',
  'social.viewPosts': 'View {count} stories from {name}',
  'social.viewUserStories': 'View stories from {name}',

  'imagePicker.title': 'Add photo',
  'imagePicker.addToStory': 'Add to story',
  'imagePicker.recents': 'Recents',
  'imagePicker.gallery': 'Gallery',
  'imagePicker.camera': 'Camera',
  'imagePicker.choosePhoto': 'Choose photo',
  'imagePicker.loading': 'Loading photos',
  'imagePicker.captionLabel': 'Caption (optional)',
  'imagePicker.captionPlaceholder': 'Write something…',
  'social.addProfileComingSoon': 'Add your profile (coming soon)',
  'social.profileComingSoon': '{name} (coming soon)',

  'social.composer.title': 'New story',
  'social.composer.expiryHint': 'Stories disappear after 48 hours. You can keep up to 5 active stories.',
  'social.composer.message': 'Caption (optional)',
  'social.composer.messagePlaceholder': 'Add a short caption…',
  'social.composer.mediaType': 'Media',
  'social.composer.modeImageAudio': 'Photo (+ optional audio)',
  'social.composer.modeVideo': 'Video',
  'social.composer.pickImage': 'Choose photo',
  'social.composer.changeImage': 'Change photo',
  'social.composer.pickAudio': 'Choose audio',
  'social.composer.pickAudioOptional': 'Add audio (optional)',
  'social.composer.changeAudio': 'Change audio',
  'social.composer.audioOptionalHint': 'Audio is optional. Longer clips are trimmed to the first 15 seconds.',
  'social.composer.videoDurationHint': 'Videos up to {maxMb} MB. Longer clips are trimmed to the first 30 seconds.',
  'social.composer.trimmedNotice': 'Media trimmed to the allowed length.',
  'social.composer.trimmedAudioNotice': 'Audio trimmed to the first 15 seconds.',
  'social.composer.trimmedVideoNotice': 'Video trimmed to the first 30 seconds.',
  'social.composer.preparingMedia': 'Preparing media…',
  'social.composer.pickVideo': 'Choose video',
  'social.composer.changeVideo': 'Change video',
  'social.composer.publish': 'Publish story',
  'social.composer.publishing': 'Publishing…',
  'social.composer.error.generic': 'Could not publish this story. Try again.',
  'social.composer.error.social-missing-media': 'Choose a photo to publish.',
  'social.composer.error.social-image-type': 'Choose a photo file.',
  'social.composer.error.social-image-too-large': 'Photo is too large.',
  'social.composer.error.social-audio-type': 'Choose an audio file.',
  'social.composer.error.social-audio-too-large': 'Audio file is too large.',
  'social.composer.error.social-audio-duration': 'Could not read the audio length.',
  'social.composer.error.social-audio-trim': 'Could not trim this audio clip. Try a shorter file.',
  'social.composer.error.social-video-type': 'Choose a video file.',
  'social.composer.error.social-video-too-large': 'Video is too large (max {maxMb} MB).',
  'social.composer.error.social-video-duration': 'Could not read the video length.',
  'social.composer.error.social-video-trim': 'Could not trim this video. Try a shorter file.',
  'social.composer.error.social-save-failed': 'Could not publish this story. Try again in a moment.',
  'social.composer.error.social-post-limit': 'You can keep up to 5 active stories. Remove an older one first.',
  'social.composer.error.social-server-error':
    'The server could not save this story (error 500). Your backend team should check the stories service logs.',
  'social.viewer.prev': 'Previous story',
  'social.viewer.next': 'Next story',
  'social.viewer.pause': 'Pause story',
  'social.viewer.resume': 'Resume story',
  'social.viewer.close': 'Close stories',
  'social.viewer.prevAccount': 'Previous account',
  'social.viewer.nextAccount': 'Next account',
  'social.viewer.mute': 'Mute sound',
  'social.viewer.unmute': 'Unmute sound',
  'social.viewer.storyIndex': '{current} / {total}',
  'social.viewer.hoursAgo': '{hours}h ago',
  'social.viewer.daysAgo': '{days}d ago',
  'social.viewer.remove': 'Remove story',
  'social.viewer.removeConfirm': 'Remove this story? It will disappear from your strip.',
  'social.viewer.removing': 'Removing…',
  'social.viewer.removeFailed': 'Could not remove this story. Try again.',
  'social.viewer.message': 'Message',
  'social.viewer.messagePlaceholder': 'Message {name}…',
  'social.viewer.messageSend': 'Send',
  'social.viewer.messageSent': 'Sent',
  'social.viewer.messageSendFailed': 'Could not send message. Try again.',
  'social.viewer.openChat': 'Open chat',

  'auth.account': 'Account',
  'auth.error.userDoesNotExist': 'The user does not exist.',
  'auth.signIn': 'Sign in',
  'auth.register': 'Register',
  'auth.register.policyIntro':
    'Choose your account type below, then complete registration. Google can speed up sign-in after you register once for that type.',
  'auth.register.googleHint': 'Register or sign in as {type} with Google.',
  'auth.register.appleHint': 'Register or sign in as {type} with Apple.',
  'auth.register.assetOwnerGoogleHint':
    'Sign in with Google to fill your details. If you already have an account, you will be signed in.',
  'auth.register.assetOwnerAppleHint':
    'Sign in with Apple to fill your details. If you already have an account, you will be signed in.',
  'auth.portal.title': 'Sign in',
  'auth.portal.phoneOtpTitle': 'Phone',
  'auth.portal.phoneOtpHint': 'Enter your number to receive a one-time sign-in code',
  'auth.portal.phoneOtpLabel': 'Phone number',
  'auth.portal.phoneOtpPlaceholder': '05XXXXXXXX',
  'auth.portal.phoneOtpComingSoon': 'Phone sign-in coming soon.',
  'auth.portal.phoneOtpNotConfigured':
    'Phone sign-in needs Firebase web config. Set REACT_APP_FIREBASE_* in .env.development.local or update src/firebaseWebConfig.json. Restart npm start after changes.',
  'auth.portal.invalidPhone': 'Enter a valid mobile number (e.g. 05XXXXXXXX).',
  'auth.portal.invalidSmsCode': 'Enter the code from your SMS.',
  'auth.portal.phoneCodeSent': 'We sent a code to {phone}. Enter it below.',
  'auth.portal.changePhone': 'Use a different phone number',
  'auth.portal.smsCodePlaceholder': 'Enter the code from your SMS',
  'auth.portal.phoneOtpUserNotRegistered':
    'This phone number is not registered yet and the server could not create a lite account automatically. Register first or use email sign-in.',
  'auth.portal.phoneOtpSmsRegionBlocked':
    'SMS sign-in is not enabled for Israel (+972) in Firebase yet. Use email sign-in for now, or ask your team to allow Israel under Authentication → Settings → SMS region policy (and enable Phone under Sign-in method).',
  'auth.portal.phoneOtpPhoneAuthDisabled':
    'Phone sign-in is disabled in Firebase. Enable Phone under Authentication → Sign-in method.',
  'auth.portal.phoneOtpInvalidAppCredential':
    'Phone security check failed. In local dev, open the app at https://127.0.0.1:3020 (npm start redirects localhost automatically). Add 127.0.0.1 under Firebase → Authentication → Settings → Authorized domains, or use a Firebase test phone number.',
  'auth.portal.phoneOtpRecaptchaReset':
    'Phone security check failed (reCAPTCHA). The page will reset the check automatically — try Send code again. If it keeps failing, hard-refresh the page (Ctrl+F5).',
  'auth.portal.phoneOtpSendTimeout':
    'Phone sign-in timed out waiting for the security check. This often happens when reCAPTCHA is visible but off-screen, or when HTTPS is not trusted locally. Hard-refresh (Ctrl+F5), fix the dev certificate, or use email sign-in.',
  'auth.portal.phoneOtpSmsError39':
    'Firebase blocked this SMS (error 39). This is a Firebase anti-abuse limit — not an app bug. It can apply to your phone number, your network IP (mobile and office Wi‑Fi often share one IP), or the whole project, and the cooldown is not always one hour (24+ hours is possible). Try another network, add a test phone in Firebase Console → Authentication → Phone, or use email sign-in. In Firebase Console also check Authentication → Settings → SMS region policy (Israel +972), Usage/quotas, and that the project is on the Blaze plan for real SMS.',
  'auth.portal.phoneOtpApiNotDeployed':
    'Phone sign-in API is not enabled on this server yet (login/clients/phone returned 404). Ask your backend team to deploy the phone login routes on dev.offizz.ai, or use email sign-in for now.',
  'auth.portal.phoneOtpRegisterNotDeployed':
    'This phone number is not registered and lite register via phone is not available on the server yet (register/PrivateClient/phone returned 404). Register with email first, or ask your backend team to deploy the phone register route.',
  'auth.portal.phoneOtpInvalidFirebaseToken':
    'The server rejected the Firebase phone token (token project: {tokenProject}, app configured for: {appProject}). Ensure REACT_APP_FIREBASE_* matches the Firebase project the backend uses for Admin SDK verification.',
  'auth.portal.switchToEmail': 'Use email instead',
  'auth.portal.switchToPhone': 'Use phone instead',
  'auth.portal.emailOtpTitle': 'Email',
  'auth.portal.emailHint': 'Enter your email to receive a one-time sign-in code',
  'auth.portal.emailLabel': 'Email',
  'auth.portal.emailPlaceholder': 'you@example.com',
  'auth.portal.codeLabel': 'One-time code',
  'auth.portal.codePlaceholder': 'Enter the code from your email',
  'auth.portal.sendCode': 'Send code',
  'auth.portal.verifyCode': 'Sign in',
  'auth.portal.codeSent': 'We sent a code to {email}. Enter it below.',
  'auth.portal.changeEmail': 'Use a different email',
  'auth.portal.invalidEmail': 'Enter a valid email address.',
  'auth.portal.invalidCode': 'Enter the code from your email.',
  'auth.portal.otpNotAvailable':
    'Email code sign-in is not enabled on this server yet. Use Google or other sign-in options below.',
  'auth.portal.otpUserNotRegistered':
    'This email is not registered yet and the server could not create a lite account automatically. Ask your backend team to enable OTP find-or-create (register/PrivateClient/otp/send), or register first.',
  'auth.portal.otpWrongServerRole':
    'Email sign-in succeeded but the server assigned role_id {roleId}, not the {type} role this page expects. Your email may be linked to another account type — use the correct sign-in page or ask support.',
  'auth.portal.otpSendFailed': 'Could not send a sign-in code.',
  'auth.portal.otpVerifyFailed': 'Could not verify the sign-in code.',
  'auth.portal.otpSignInRejected':
    'Sign-in was rejected. Check your identifier and password, or account access.',
  'auth.portal.otpLoginNotFound': 'The login address could not be reached. Check the API configuration.',
  'auth.portal.otpServerError': 'The server could not complete sign-in. Try again later.',
  'auth.portal.otpRequestFailed': 'Sign-in could not be completed. Check the information you entered.',
  'auth.portal.otpSignInFailed': 'Sign-in failed.',
  'auth.portal.otpNetworkUnreachable':
    'Could not reach the server. Check your connection, proxy, or CORS settings.',
  'auth.portal.otpNetworkError': 'Something went wrong while contacting the server.',
  'auth.portal.otpInvalidCode': 'The sign-in code is incorrect. Try again.',
  'auth.portal.otpExpired': 'The sign-in code has expired. Request a new code.',
  'auth.portal.otpTooManyAttempts': 'Too many attempts. Wait a moment and try again.',
  'auth.portal.phoneHint': 'Enter your phone number or email to receive a confirmation code',
  'auth.portal.phoneLabel': 'Phone number or email',
  'auth.portal.phonePlaceholder': 'Phone number or email',
  'auth.portal.enter': 'Sign in',
  'auth.portal.or': 'or',
  'auth.portal.google': 'Sign in with Google',
  'auth.portal.googleEmailHint':
    'Use Google sign-in above. Pick the login type that matches your Placy account (not always Private client).',
  'auth.portal.googleEmailHintPrivate': 'Use Google sign-in above for this Gmail address.',
  'auth.portal.googleLoginTypeMismatch':
    'This Google account does not match the selected login type. Open Login type below and choose the role your account was registered with, then try Google again.',
  'auth.portal.googleUserNotRegistered':
    'This Google account is not registered yet and the server could not create a lite account automatically. Try email code sign-in above, or ask your backend team to enable find-or-create on Google login.',
  'auth.portal.googleWrongServerRole':
    'Google sign-in succeeded but the server assigned role_id {roleId}, not the {type} role this page expects (private clients need role_id 1). Your Google email may still be linked to another account type on the server — ask support to fix or delete it, or use Register with the correct type.',
  'auth.portal.googleNotConfigured':
    'Set REACT_APP_GOOGLE_OAUTH_CLIENT_ID (or clientId in src/devGoogleOAuthClientId.json) to enable Google sign-in.',
  'auth.portal.googleLoadFailed': 'Could not load Google Sign-In. Check your connection and try again.',
  'auth.portal.googlePlaySigning':
    'Google Sign-In is not authorized for this Play Store install. In Google Cloud, add an Android OAuth client for package ai.offizz.app using the Play App signing SHA-1 (Play Console → Protected with Play → Play app signing).',
  'auth.portal.googleNativeNotReady':
    'Google Sign-In on this device is not ready. Close the app fully and try again. If it still fails, a new Play build may be required.',
  'auth.portal.googleMissingIdToken':
    'Google Sign-In did not return an ID token. Confirm the Web client ID is set as serverClientId for the Android app.',
  'auth.portal.googleSigningIn': 'Signing in with Google…',
  'auth.portal.googleNotEnabled':
    'Google sign-in is not enabled on the server yet. Sign in with username and password below, or ask your backend team to add a Google login endpoint.',
  'auth.portal.googleUnavailable':
    'Google sign-in is not available on this server yet. Use username and password below, or try again later.',
  'auth.portal.lastUsedGoogle': 'Last used',
  'auth.portal.lastUsedPassword': 'Last used',
  'auth.portal.lastUsedOtp': 'Last used',
  'auth.portal.usePasswordInstead': 'Use password instead',
  'auth.portal.otpModeTab': 'One-time code',
  'auth.portal.passwordModeTab': 'Password',
  'auth.portal.backToOtp': 'Back to one-time code',
  'auth.portal.passwordHint': 'Enter your email and password to sign in',

  'auth.forgotPassword.link': 'Forgot password?',

  'auth.forgotPassword.title': 'Reset your password',
  'auth.forgotPassword.intro':
    'Enter the email or phone on your account. We will send a one-time code so you can set a new password.',
  'auth.forgotPassword.emailHint': 'Enter your email to receive a reset code',
  'auth.forgotPassword.phoneHint': 'Enter your phone number to receive a reset code',
  'auth.forgotPassword.codeSentEmail': 'We sent a code to {email}. Enter it below.',
  'auth.forgotPassword.codeSentPhone': 'We sent a code to {phone}. Enter it below.',
  'auth.forgotPassword.verifyCode': 'Verify code',
  'auth.forgotPassword.setPasswordHint': 'Choose a new password for this account.',
  'auth.forgotPassword.newPassword': 'New password',
  'auth.forgotPassword.confirmPassword': 'Confirm new password',
  'auth.forgotPassword.submitNewPassword': 'Update password',
  'auth.forgotPassword.success': 'Password updated. Sign in with your new password.',
  'auth.forgotPassword.backToSignIn': 'Back to sign in',
  'auth.forgotPassword.mismatch': 'New password and confirmation must match.',
  'auth.forgotPassword.passwordRequired': 'Enter a new password.',
  'auth.forgotPassword.userNotFound':
    'No account was found for this email. Check the address, or register first.',
  'auth.forgotPassword.phoneUserNotFound':
    'No account was found for this phone number. Check the number, or register first.',
  'auth.forgotPassword.sendFailed': 'Could not send a reset code.',
  'auth.forgotPassword.verifyFailed': 'Could not verify the reset code.',
  'auth.forgotPassword.completeFailed': 'Could not update the password. Try again.',
  'auth.forgotPassword.noResetToken':
    'The reset code was accepted but no reset token was returned. Try again, or contact support.',
  'auth.forgotPassword.noPasswordAccount':
    'This account does not use a password. Sign in with Google, Apple, or a one-time code.',
  'auth.forgotPassword.tokenExpired': 'The reset code has expired. Request a new code.',
  'auth.portal.apple': 'Log In with Apple',
  'auth.portal.appleLoginTypeMismatch':
    'This Apple account does not match the selected login type. Open Login type below and choose the role your account was registered with, then try Apple again.',
  'auth.portal.appleUserNotRegistered':
    'This Apple account is not registered yet and the server could not create a lite account automatically. Try email code sign-in above, or ask your backend team to enable find-or-create on Apple login.',
  'auth.portal.appleWrongServerRole':
    'Apple sign-in succeeded but the server assigned role_id {roleId}, not the {type} role this page expects (private clients need role_id 1). Your Apple email may still be linked to another account type on the server — ask support to fix or delete it, or use Register with the correct type.',
  'auth.portal.appleNotConfigured':
    'Apple Sign-In needs Services ID ai.offizz.dev and a Return URL that matches REACT_APP_APPLE_REDIRECT_URI (dev: https://dev.offizz.ai/auth/apple/callback, app: https://app.offizz.ai/auth/apple/callback).',
  'auth.portal.appleLoadFailed': 'Could not complete Apple Sign-In. Check your connection and try again.',
  'auth.portal.appleSigningIn': 'Signing in with Apple…',
  'auth.portal.appleNotEnabled':
    'Apple sign-in is not enabled on the server yet. Sign in with username and password below, or ask your backend team to add an Apple login endpoint.',
  'auth.portal.appleUnavailable':
    'Apple sign-in is not available on this server yet. Use username and password below, or try again later.',
  'auth.portal.appleMissingToken':
    'Apple sign-in did not send an identity token. Try again, or use another sign-in method.',
  'auth.portal.appleInvalidToken':
    'Apple identity token was rejected (invalid, expired, or wrong audience). Confirm the Services ID is ai.offizz.dev — not App ID ai.offizz.app.',
  'auth.portal.lastUsedApple': 'Last used',
  'auth.portal.credentialsTitle': 'Sign in with username and password',
  'auth.portal.username': 'Username',
  'auth.portal.comingSoon': 'Coming soon',
  'auth.portal.noAccount': "Don't have an account?",
  'auth.portal.registerLink': 'Register',
  'auth.portal.mainGoogleHint': 'Sign in or register with Google.',
  'auth.portal.roleGoogleHint':
    'Use Google for {type} if you already registered that account type with Google.',
  'auth.portal.otherSignInOptions': 'Other sign in options',
  'auth.portal.assetOwnerLink': 'Asset owner',
  'auth.assetOwner.signInTitle': 'Asset owner sign in',
  'auth.assetOwner.signInIntro': 'Sign in to manage your listings, bookings, and business profile.',
  'auth.assetOwner.registerTitle': 'Asset owner registration',
  'auth.assetOwner.registerLink': 'Register as asset owner',
  'auth.portal.otherSignInTitle': 'Other sign in and registration options',
  'auth.portal.otherSignInIntro':
    'Sign in with username and password, or choose your account type.',
  'auth.portal.contactPageTitle': 'Contact us',
  'auth.portal.contactPageIntro': 'Reach our team by email and we will help you sign in.',
  'auth.portal.contactEmailLabel': 'Email',
  'auth.portal.contactWhatsAppLabel': 'WhatsApp',
  'auth.portal.contactPrompt': 'Having trouble?',
  'auth.portal.contactAction': 'Contact us',
  'auth.portal.clearAppData': 'Clear cached app data',
  'auth.portal.clearAppDataBusy': 'Clearing…',
  'auth.portal.clearAppDataConfirm':
    'Clear all saved app data on this device? You will be signed out. Cached names and rebuildable lists will be removed, then the page reloads. Your favourites, booking details, asset drafts, profile hints, and language choice are kept on this device.',

  'login.login': 'Login',
  'login.loginType': 'Login type',
  'login.identifier': 'Identifier',
  'login.password': 'Password',
  'login.credentialsRequired': 'Enter your identifier and password.',
  'login.clear': 'Clear',
  'login.blockedSignedIn': 'You are already signed in.',
  'login.blockedSignInElse': 'You are already signed in. Log out to sign in as someone else.',
  'login.signInNoToken': 'Sign-in succeeded but the response was not valid JSON with an accessToken.',
  'login.signInEmptyBody': 'Sign-in succeeded (HTTP {status}) but the response body was empty — accessToken is required.',
  'login.option.businessClient': 'Business client',
  'login.option.privateClient': 'Private client',
  'login.option.businessWorker': 'Business worker',
  'login.option.assetOwner': 'Asset owner',
  'login.option.businessAssetOwner': 'Asset owner',
  'login.option.privateAssetOwner': 'Asset owner',

  'auth.passwordRequirementsInParentheses':
    '(minimum 8 characters; 1 uppercase A–Z; 1 lowercase a–z; 1 digit 0–9; 1 special character e.g. @ # $ % !)',

  'register.register': 'Register',
  'register.registerType': 'Register type',
  'register.contactFirstName': 'Contact first name',
  'register.contactLastName': 'Contact last name',
  'register.assetOwnerPayout.title': 'Bank account for payouts',
  'register.assetOwnerPayout.payoutCountry': 'Payout country',
  'register.assetOwnerPayout.countryIl': 'Israel',
  'register.assetOwnerPayout.countryUs': 'United States',
  'register.assetOwnerPayout.accountHolderName': 'Account holder name',
  'register.assetOwnerPayout.bankNumber': 'Bank number',
  'register.assetOwnerPayout.branchNumber': 'Branch number',
  'register.assetOwnerPayout.accountNumber': 'Account number',
  'register.assetOwnerPayout.routingNumber': 'Routing number (ABA)',
  'register.assetOwnerPayout.accountType': 'Account type',
  'register.assetOwnerPayout.accountTypeChecking': 'Checking',
  'register.assetOwnerPayout.accountTypeSavings': 'Savings',
  'register.assetOwnerPayout.transferDay': 'Payment transfer day',
  'register.assetOwnerPayout.transferDayOption.2': 'The 2nd of each month',
  'register.assetOwnerPayout.transferDayOption.10': 'The 10th of each month',
  'register.assetOwnerPayout.transferDayOption.15': 'The 15th of each month',
  'register.assetOwnerPayout.selectTransferDay': 'Select transfer day…',
  'register.assetOwnerPayout.selectAccountType': 'Select account type…',
  'register.assetOwnerPayout.hintIl':
    'Israeli domestic payouts use bank number (2 digits), branch (3 digits), and account number.',
  'register.assetOwnerPayout.hintUs':
    'US ACH payouts use a 9-digit routing number and checking or savings account number.',
  'register.assetOwnerPayout.error.accountHolderRequired': 'Enter the name on the bank account.',
  'register.assetOwnerPayout.error.accountNumberRequired': 'Enter the account number.',
  'register.assetOwnerPayout.error.accountNumberReenter':
    'Re-enter your full account number to save payment changes (the saved number is partially hidden for security).',
  'register.assetOwnerPayout.error.bankNumberIl': 'Bank number must be 2 digits (e.g. 12 for Hapoalim).',
  'register.assetOwnerPayout.error.branchNumberIl': 'Branch number must be 3 digits.',
  'register.assetOwnerPayout.error.accountNumberIl': 'Enter a valid Israeli account number (digits only).',
  'register.assetOwnerPayout.error.routingNumberUs': 'Routing number must be 9 digits.',
  'register.assetOwnerPayout.error.accountNumberUs':
    'US account number must be 4–17 digits.',
  'register.assetOwnerPayout.error.accountTypeUs': 'Select checking or savings.',
  'register.assetOwnerPayout.error.transferDayRequired': 'Select a payment transfer day.',
  'register.businessLogo': 'Business logo',
  'register.businessLogoAdd': 'Add business logo',
  'register.businessLogoChange': 'Change logo',
  'register.businessLogoRemove': 'Remove',
  'register.businessLogoAfterSignIn':
    'Optional. The logo is saved to your profile after you sign in (not sent during registration).',
  'register.businessLogoTooLarge': 'Logo file must be 12 MB or smaller.',
  'register.businessLogoTooLargePayload':
    'Logo is too large for registration (the full request must stay under about 100 KB). Try a smaller or simpler image.',
  'register.success': 'User registered successfully.',
  'register.successWithEmail': 'Registration complete. Your account email is {email}.',
  'register.successOtherSignInHint':
    'To sign in, choose {type} on the next screen and use this email with your password (not the main phone/email code screen).',
  'register.successBusinessClientWorkerCode':
    'Share this 8-digit code with employees so they can register as business workers: {code}',
  'register.successBusinessClientWorkerCodeHint':
    'Workers choose Business worker on the register page and enter this code in the employer field.',
  'register.successBusinessClientWorkerCodePending':
    'Your business account was created. Sign in as a business client and open Profile → Details to view your 8-digit worker registration code.',
  'register.copyWorkerCode': 'Copy code',
  'register.copyWorkerCodeDone': 'Copied',
  'register.businessClientWorkerCode': 'Employer code (8 digits)',
  'register.businessWorkerCodeHint':
    'Enter the 8-digit code your employer received when the business account was created.',
  'register.goToSignIn': 'Go to sign in',
  'register.error.userAlreadyExists':
    'A user with this email, phone number, or business ID already exists on the server (including deactivated accounts after Erase account).',
  'register.error.userAlreadyExistsSubmitted':
    'Values sent in this request: email “{email}”, phone “{phone}”, business ID “{businessId}”. The server rejects the registration if any one of them is already taken — not only when all three match a previous account.',
  'register.error.userAlreadyExistsGoogleEmail':
    'You signed up with Google, so the email comes from your Google account and cannot be changed on this form. Use another Google account, or sign in with this email instead of registering again.',
  'register.error.userAlreadyExistsTryLogin':
    'Try Log in as a business client with this email and password. For a brand-new account, use an email, phone, and business ID that were never used on Placy, or contact support to release the old identifiers.',
  'register.error.userAlreadyExistsPrivateClient':
    'A user with this email or phone number already exists on the server (including deactivated accounts after Erase account).',
  'register.error.userAlreadyExistsSubmittedPrivateClient':
    'Values sent in this request: email “{email}”, phone “{phone}”. No business ID is sent for private-client registration. The server rejects the registration if either email or phone is already taken.',
  'register.error.userAlreadyExistsTryLoginPrivateClient':
    'Try Log in as a private client with this email and password. For a brand-new account, use an email and phone that were never used on Placy, or contact support to release the old identifiers.',
  'register.error.badRequest':
    'The registration data is invalid. Check required fields, email format, phone number, and bank details.',
  'register.error.badRequestWithStatus':
    'Registration was rejected (error {status}). Check required fields, email, phone, business ID, country, and bank details.',
  'register.error.conflict': 'This account already exists or conflicts with another user.',
  'register.error.conflictWithStatus':
    'Registration conflict (error {status}). This email or phone may already belong to an existing or deactivated account. Try Log in, or use different contact details.',
  'register.error.forbidden': 'You are not allowed to register with these credentials.',
  'register.error.rejected':
    'Registration was not accepted. This email or phone may already be registered — try signing in instead. If you need a different account type, pick the matching registration type above or use a different email.',
  'register.error.businessWorkerPublicRejected':
    'Business worker registration was not accepted. Check the 8-digit employer code from your business account. If this email or phone is already registered, sign in instead.',
  'register.error.businessWorkerSessionRejected':
    'Your business-client session is no longer valid. Sign in again as the business client, then add the worker from your profile.',
  'register.error.businessWorkerSessionRequired':
    'Sign in again as a business client to register a worker from your profile, or log out and use the public register page with the 8-digit employer code.',
  'register.error.staleSession':
    'A previous sign-in session is still affecting registration. Log out again, hard-refresh this page, or try in a private window, then register with a new email if this account type differs from the one you signed out of.',
  'register.error.forbiddenWithStatus': 'Registration was not allowed (error {status}).',
  'register.error.serverWithStatus':
    'The server could not complete registration (error {status}). Try again later.',
  'register.error.serverInternalHint':
    'The server could not complete registration (error {status}). If you erased an account with the same email or phone, that contact info may still be reserved — try Log in, use different contact details, or contact support. Otherwise share the technical details with your backend team.',
  'register.error.requestFailedWithStatus': 'Registration failed (error {status}).',
  'register.error.fieldRequired': '{field} is required.',
  'register.error.fieldInvalidEmail': 'Enter a valid email address for {field}.',
  'register.error.fieldInvalidPhone': 'Enter a valid phone number for {field}.',
  'register.error.fieldInvalidString': '{field} must be text.',
  'register.error.fieldInvalidNumber': '{field} must be a number.',
  'register.error.fieldConstraint': '{field}: {detail}',
  'register.error.requestFailed': 'Registration failed. Try again.',

  'userType.businessClient': 'Business client',
  'userType.privateClient': 'Private client',
  'userType.businessWorker': 'Business worker',
  'userType.assetOwner': 'Asset owner',
  'userType.businessAssetOwner': 'Asset owner',
  'userType.privateAssetOwner': 'Asset owner',

  'assets.title': 'Assets',
  'assets.myAssetsTitle': 'My assets',
  'assets.ownerEmpty': 'You have not created any assets yet. Switch to Create to add one.',
  'assets.ownerMode': 'Asset owner',
  'assets.apiLabel': 'Asset API',
  'assets.operation.getById': 'Asset (display / edit / delete)',
  'assets.operation.listMine': 'List my Assets',
  'assets.operation.active': 'Active Assets',
  'assets.operation.create': 'Create Asset',
  'assets.filter.country': 'Country',
  'assets.filter.region': 'Region',
  'assets.filter.assetType': 'Asset type',
  'assets.filter.nameContains': 'Name contains',
  'assets.filter.nameOrAddressContains': 'Name, address, or description contains',
  'assets.filter.allCountries': 'All countries',
  'assets.filter.allRegions': 'All regions',
  'assets.filter.allTypes': 'All types',
  'assets.filter.selectCountryFirst': 'Select a country first',
  'assets.filter.loadingRegions': 'Loading regions…',
  'assets.filter.noRegions': 'No regions for this country',
  'assets.filter.listFilters': 'List filters',
  'assets.filter.listFiltersTitle': 'List filters',
  'assets.filter.placeholderSubstring': 'At least 3 letters…',
  'assets.filter.placeholderUuid': 'UUID',
  'assets.filter.placeholderAssetId': 'UUID or 8-digit ID',
  'assets.filter.noMatch': 'No assets match your filters.',
  'assets.filter.noOpen24h': 'No listings with 24/7 access in {city}.',
  'assets.filter.noOpen24hGeneric': 'No listings with 24/7 access.',
  'assets.filter.searchAllOffices': 'Search all offices in {city}',
  'assets.filter.searchAllOfficesGeneric': 'Search all offices',
  'assets.search.loading': 'Loading assets…',
  'assets.search.loadingMore': 'Loading more…',
  'assets.search.loadingMoreListings': 'More listings are still loading…',
  'assets.search.loadMore': 'Load more',
  'assets.search.endOfList': 'You have reached the end of the list.',
  'assets.search.resultCount': 'Showing {count} of {total}',
  'assets.search.resultCountPartial': 'Showing {count} so far',
  'assets.filter.clearFilters': 'Clear filters',
  'assets.filter.sort': 'Sort by',
  'assets.filter.sortName': 'Name (A–Z)',
  'assets.filter.sortPriceAsc': 'Price: low to high',
  'assets.filter.sortPriceDesc': 'Price: high to low',
  'assets.filter.sortDistance': 'Distance',
  'form.picklist.loadingCountries': 'Loading countries…',
  'form.picklist.selectCountry': 'Select country…',
  'form.picklist.unavailable': 'Unavailable',
  'form.picklist.loadingRegions': 'Loading regions…',
  'form.picklist.selectRegion': 'Select region…',
  'form.picklist.regionsUnavailable': 'Regions unavailable',
  'form.picklist.noRegionsApi': 'No regions returned',
  'form.picklist.pickRegionStale': 'Pick a region (list may be stale)',
  'form.picklist.loadingAssetTypes': 'Loading asset types…',
  'form.picklist.selectAssetType': 'Select asset type…',
  'form.picklist.searchCity': 'Search city or settlement…',
  'form.picklist.citySettlementHint': '{count} official Israeli settlements — type to filter.',
  'form.picklist.selectCityFirst': 'Select a city first…',
  'form.picklist.searchStreet': 'Search street…',
  'form.picklist.streetManualPlaceholder': 'Enter street name…',
  'form.picklist.streetManualOverride': 'Enter street manually (not in the list)',
  'form.picklist.streetNeedsCity': 'Pick a city to load official streets for that locality.',
  'form.picklist.streetHint': '{count} official streets in this city — type to filter.',
  'form.picklist.streetNoOfficialList': 'No official street list for this city — use manual entry.',
  'form.picklist.zipAutoPlaceholder': 'Filled automatically',
  'form.picklist.zipAutoHint': 'Postal code is resolved from the city and street you enter.',
  'form.picklist.buildingPlaceholder': 'House / building number',
  'assets.book.available': 'Available for booking',
  'assets.book.view': 'View asset',
  'assets.signInToUse': 'Sign in as an asset owner, client, or business worker to use Assets.',
  'assets.availableRoles': 'Assets are available for asset owners, clients, and business workers.',
  'assets.createNotForClients': 'Creating assets is not available for business or private client accounts.',
  'assets.afterDisplayActions': 'After display actions',
  'assets.chooseImagesUpload': 'Choose image files (up to five)',
  'assets.assetImages': 'Asset images',
  'assets.chooseImagesUpdate': 'Choose image files for update',
  'assets.addUpToTenImages': 'Add up to 10 images',
  'assets.mainImage': 'Main image',
  'assets.mainImageListHint': 'Shown in asset lists',
  'assets.additionalImages': 'Additional images',
  'assets.browseMainImage': 'Choose main image…',
  'assets.browseAdditionalImages': 'Add more images…',
  'assets.removeImage': 'Remove',
  'assets.noMainImageYet': 'No main image chosen yet.',
  'assets.noAdditionalImagesYet': 'No additional images yet.',
  'assets.additionalImageLabel': 'Image {n}',
  'assets.imagesSelected': '{n} / {max} selected',
  'assets.imagesRePickRequired':
    'Image files are no longer attached. Choose your images again before creating the asset.',
  'assets.imagesAtLeastOne': 'Add at least one image before creating the asset.',
  'assets.imagesTooMany': 'You can attach at most {max} image files.',
  'assets.imagesFileTooLarge':
    'Image “{name}” is {sizeMb} MB; each file must be at most {maxMb} MB.',
  'assets.createPayloadFailed': 'Could not prepare the create request.',
  'assets.idRequired': 'Asset ID is required.',
  'assets.shortIdNotInCatalog':
    'No active listing found for ID {id}. It may be delisted or the ID may be mistyped.',
  'assets.updateNotForAccount': 'Updating assets is not available for your account type.',
  'assets.noChangesToSave': 'No changes to save.',
  'assets.availabilityNotPersisted':
    'The server accepted the save but did not change booking availability ({tried}). Ask the backend team to allow asset_status on PATCH /assets/:id.',
  'assets.geo.title': 'Map location',
  'assets.geo.coordsSet': 'Coordinates: {lat}, {lng}',
  'assets.geo.coordsUnset':
    'No coordinates yet. Use “Look up from address” or “Open in Google Maps” to resolve them from your street address, then fine-tune if needed.',
  'assets.geo.pickOnMap': 'Set coordinates',
  'assets.geo.openGoogleMaps': 'Open in Google Maps',
  'assets.geo.fromAddress': 'Look up from address',
  'assets.geo.lookingUp': 'Looking up…',
  'assets.geo.needAddress': 'Enter at least a city and street in the address first.',
  'assets.geo.geocodeFailed': 'Could not determine coordinates. Check the address and try again.',
  'assets.geo.invalidCoords': 'Enter valid latitude (-90…90) and longitude (-180…180).',
  'assets.geo.dialogTitle': 'Asset coordinates',
  'assets.geo.dialogHint':
    'Use “Look up from address” or “Open in Google Maps” to resolve coordinates from your address. Adjust latitude and longitude here if you need to fine-tune, then click Apply.',
  'assets.geo.latitude': 'Latitude',
  'assets.geo.longitude': 'Longitude',
  'assets.geo.apply': 'Apply',
  'assets.loadingFacilities': 'Loading facilities…',
  'assets.noFacilitiesInApi': 'No facilities in the API response.',
  'assets.retry': 'Retry',
  'assets.addUrl': 'Add URL',
  'assets.imageUrlPlaceholder': 'https://… or /path/to/image.jpg',
  'assets.noImagesInThisListYet':
    'No images in this list yet. Add files or URLs below, or omit images on save to leave them unchanged.',
  'assets.imageUrlAria': 'Image URL or path to add',
  'assets.facilitiesAria': 'Facilities for this asset',
  'assets.transportationAccessibility': 'Transportation and Accessibility',
  'assets.transportationAria': 'Transportation and accessibility options for this asset',
  'assets.noTransportationFacilities': 'No transportation or accessibility options are available from the API yet.',
  'assets.createTerms': 'Terms',
  'assets.createTermsPlaceholder':
    'Placeholder terms for asset listing. Replace this text with your owner agreement, cancellation policy, and house rules before going live.',
  'assets.createTermsAgree': 'I agree to the terms',
  'assets.createTermsRequired': 'You must agree to the terms before creating an asset.',
  'assets.createContactConflict':
    'Asset create was rejected because the server thinks this contact email or phone already belongs to another user. Refresh the page and try again. If it keeps happening, contact support.',
  'assets.pricingPriceRequired':
    'Enter a price of zero or greater for each selected pricing type.',
  'assets.pricingAria': 'Pricing methods for this asset',
  'assets.addonsAria': 'Add-ons for this asset',
  'assets.bookSignIn': 'Sign in to book this asset.',
  'assets.failedFacilities': 'Failed to load facilities.',
  'assets.failedAddons': 'Failed to load add-ons.',
  'assets.failedPricing': 'Failed to load pricing types.',
  'assets.pricingTypesLegend': 'Pricing types',
  'assets.pricingSuggestEstimate':
    'Suggested for {type} in {city}: {hourly}/hr · {daily}/day · {monthly}/mo (location & type estimate).',
  'assets.pricingSuggestMarket':
    'Suggested for {type} in {city}: {hourly}/hr · {daily}/day · {monthly}/mo (median of {n} similar listings).',
  'assets.pricingSuggestApply': 'Apply suggestions',
  'assets.pricingSuggestAnyType': 'this type',
  'assets.pricingSuggestAnyCity': 'this area',
  'assets.loadingPricingTypes': 'Loading pricing types…',
  'assets.noPricingTypes': 'No pricing types in the API response.',
  'assets.failedCountries': 'Failed to load countries',
  'assets.failedAssetTypes': 'Failed to load asset types',
  'assets.failedDistricts': 'Failed to load districts',
  'assets.failedRegions': 'Failed to load regions',
  'assets.updateOwnerOnly': 'Update is only available for assets you own.',
  'assets.noAssetId': 'This row has no asset id — cannot update.',
  'assets.cannotReadResponse': 'Asset response could not be read as an object.',
  'assets.deleteIdRequired': 'Asset ID is required for delete.',
  'assets.createSuccess': 'Asset created successfully. Asset ID: {id}',
  'assets.updateSuccess': 'Asset updated successfully. Asset ID: {id}',
  'assets.editDisplayed': 'Edit asset',
  'assets.deleteDisplayed': 'Delete asset',
  'assets.backToList': '← Back to list',
  'assets.backToSearch': '← Back to search',
  'assets.updateAsset': 'Update asset',
  'assets.cancelEdit': 'Cancel edit',
  'assets.bookingAvailabilityLegend': 'Booking visibility',
  'assets.availableForBooking': 'Available for booking',
  'assets.statusUnavailableBadge': 'Unavailable',
  'assets.ownerSchedule.title': 'Booking calendar',
  'assets.ownerSchedule.viewMode': 'Calendar view',
  'assets.ownerSchedule.viewDay': 'Day',
  'assets.ownerSchedule.viewWeek': 'Week',
  'assets.ownerSchedule.viewMonth': 'Month',
  'assets.ownerSchedule.prev': 'Previous period',
  'assets.ownerSchedule.next': 'Next period',
  'assets.ownerSchedule.bookingCount': '{n} bookings for this asset',
  'assets.ownerSchedule.noBookings': 'No bookings on this day.',
  'assets.ownerSchedule.unknownBooker': 'Unknown guest',
  'assets.ownerSchedule.peopleCount': '{n} people',
  'assets.ownerSchedule.loadError': 'Could not load bookings for this asset.',
  'assets.ownerSchedule.legendTitle': 'Calendar legend',
  'assets.ownerSchedule.legendClosed': 'Closed',
  'assets.ownerSchedule.legendOpenEmpty': 'Open (no bookings)',
  'assets.ownerSchedule.legendOpenBookings': 'Open (has bookings)',
  'assets.ownerSchedule.legendBlackout': 'Blackout',
  'assets.ownerSchedule.dayClosed': 'This day is closed or blacked out.',

  'bookings.title': 'Bookings',
  'bookings.apiLabel': 'Booking API',
  'bookings.formNav': 'Booking form navigation',
  'bookings.operation.getById': 'Booking by ID',
  'bookings.operation.listAll': 'My Bookings',
  'bookings.operation.create': 'Create Booking',
  'bookings.operation.modifyPrice': 'Modify Price',
  'bookings.operation.cancelClient': 'Cancel (client)',
  'bookings.operation.cancelOwner': 'Cancel (owner)',
  'bookings.operation.escalate': 'Escalate to Support',
  'bookings.howMany': 'How many',
  'bookings.howManyHours': 'Number of hours',
  'bookings.startFixed': 'Start (fixed)',
  'bookings.endCalculated': 'End (calculated)',
  'bookings.periodEndRoundedUp':
    'Your end date was rounded up to {end} ({periods}) to match full billing periods.',
  'bookings.totalPriceCalculated': 'Total price (calculated)',
  'bookings.numberOfPeople': 'Number of people',
  'bookings.bookingPeriod': 'Booking period',
  'bookings.pricing': 'Pricing',
  'bookings.optionalAddons': 'Optional add-ons',
  'bookings.cancelEdit': 'Cancel edit',
  'bookings.cancelBooking': 'Cancel booking',
  'bookings.cancelSuccess': 'Booking cancelled.',
  'bookings.cancelOrphanSuccess':
    'Booking removed from your list. The linked place is no longer available, so it could not be cancelled on the server.',
  'bookings.backToList': 'Back to list',
  'bookings.backToBookings': 'Back to bookings',
  'bookings.backToAssetsLabel': '← Back to assets',
  'bookings.backToBookingsLabel': '← Back to bookings',
  'bookings.placeholderUuid': 'UUID',
  'bookings.calendar.title': 'Choose dates',
  'bookings.calendar.titleHourly': 'Choose day and time',
  'bookings.calendar.titleExtend': 'Availability calendar',
  'bookings.calendar.hint': 'Choose Start or End, then tap a day on the calendar. Striped days are reserved.',
  'bookings.calendar.hintHourly':
    'Tap a day on the calendar, then choose a start time and number of hours.',
  'bookings.calendar.hintExtend':
    'Tap a day to extend the end date. Striped days are reserved by other bookings.',
  'bookings.calendar.hintHourlyExtend':
    'Change the number of hours below to extend the booking. Striped days are reserved.',
  'bookings.calendar.startDate': 'Start date',
  'bookings.calendar.selectedDay': 'Day',
  'bookings.calendar.endDate': 'End date',
  'bookings.calendar.notSelected': 'Not selected',
  'bookings.calendar.pickStart': 'Pick start date',
  'bookings.calendar.pickEnd': 'Pick end date',
  'bookings.calendar.pickEndNeedsStart': 'Pick a start date first.',
  'bookings.calendar.startTime': 'Start time',
  'bookings.calendar.endTime': 'End time',
  'bookings.calendar.hourlyHint': 'Set the hour for each period (after choosing dates).',
  'bookings.calendar.hourlySameDayHint':
    'Choose a start time. End time is calculated from the number of hours.',
  'bookings.calendar.endTimeAuto': 'Choose number of hours below',
  'bookings.calendar.reservedLegend': 'Reserved',
  'bookings.calendar.closedLegend': 'Closed / blackout',
  'bookings.calendar.rangeLegend': 'Your selection',
  'bookings.calendar.prevMonth': 'Previous month',
  'bookings.calendar.nextMonth': 'Next month',
  'bookings.calendar.loading': 'Loading reservations…',
  'bookings.calendar.rangeBlocked': 'That range includes reserved days — pick different dates.',

  'bookings.scheduleError.chooseStart': 'Choose a start date and time.',
  'bookings.scheduleError.chooseEnd': 'Choose an end date and time.',
  'bookings.scheduleError.invalidDates': 'Start and end dates must be valid.',
  'bookings.scheduleError.endBeforeStart': 'End must be after start.',
  'bookings.scheduleError.startTooSoon':
    'Start time is too soon — choose a time at least a few minutes from now.',
  'bookings.scheduleError.hourlySameDay': 'Hourly bookings must start and end on the same day.',
  'bookings.scheduleError.hourlySameDayEnd':
    'Hourly bookings must end on the same day as the start.',
  'bookings.scheduleError.startTooLateToday':
    'Start time is too late — not enough time left today for an hourly booking.',
  'bookings.scheduleError.startInPast': 'Start date cannot be in the past.',
  'bookings.scheduleError.missingBookingStart':
    'Booking start date is missing — reload the booking and try again.',
  'bookings.scheduleError.invalidEnd': 'End date must be valid.',
  'bookings.scheduleError.endBeforeBookingStart': 'End must be after the booking start.',
  'bookings.scheduleError.periodAlign': 'End must align with complete booking periods.',
  'bookings.scheduleError.cannotShortenBelow': 'Cannot shorten below {periods}.',
  'bookings.scheduleError.periodCountMismatch':
    'End must match the period count ({periods}) from the booking start.',

  'bookings.titleUpdate': 'Update booking',
  'bookings.titleCreate': 'Create booking',
  'bookings.extendLegend': 'Extend booking',
  'bookings.paymentOption': 'Payment option:',
  'bookings.periodStartPlus': 'Start + {period}',
  'bookings.totalPriceBasedOn':
    'Based on {pricing} at {price} per period plus selected add-ons.',
  'bookings.totalPriceBasedOnNoUnit': 'Based on {pricing} plus selected add-ons.',
  'bookings.totalPriceHintEnd':
    'Set end after start and ensure this asset has a price for the booking period.',
  'bookings.loadingAssetRates': 'Loading asset rates…',
  'bookings.loadingOptions': 'Loading booking options from asset…',
  'bookings.schedule': 'Schedule',
  'bookings.startDate': 'Start date',
  'bookings.startDateTime': 'Start date & time',
  'bookings.startLegend': 'Start',
  'bookings.endLegend': 'End',
  'bookings.addonsLegend': 'Add-ons',
  'bookings.noBookingsListed': 'No bookings listed',
  'bookings.noUpcomingBookingsListed': 'No current bookings',
  'bookings.noPastBookingsListed': 'No booking history',
  'bookings.list.timeFilterLabel': 'Booking list',
  'bookings.list.timeFilterCurrent': 'Current Bookings',
  'bookings.list.timeFilterPast': 'Booking History',
  'bookings.discardEdit': 'Discard changes to this reservation?',
  'bookings.discardCreate': 'Discard this booking?',
  'bookings.couldNotCalculateTotal':
    'Could not calculate total price — check end date is after start and asset pricing loaded.',
  'bookings.error.assetNotBookable':
    'This place is no longer available to book. It may have been removed or delisted. Go back to Browse and pick another space.',
  'bookings.error.assetLoadSession':
    'Your session could not be verified. Sign in again, then retry booking.',
  'bookings.error.assetLoadIpMismatch':
    'Your session is tied to a different network address. Sign in again from this browser, then retry.',
  'bookings.error.peopleExceedsCapacity':
    'Requested amount of people exceeds available capacity of {capacity} for the selected dates',
  'bookings.error.roleNotAllowed':
    'Your account is not allowed to create bookings. Only private clients and business workers can book places.',
  'bookings.error.roleNotAllowedHint':
    'If you signed in with Google, the server may have created your account without the private-client role. Log out, register as a private client with email and password (or use a fresh Google email), or ask support to fix your account role. Do not use two browser windows on the same localhost for owner and client — they share one login session.',
  'bookings.error.completeRegistration': 'Complete your profile before booking.',
  'bookings.error.completeRegistrationServer.title': 'Booking blocked by the server',
  'bookings.error.completeRegistrationServer.body':
    'Your profile already has name, email, phone, and date of birth. The booking service still rejected this as an incomplete registration. That flag is on the backend, not in this app — ask support to clear the lite/incomplete-registration state for this Google account.',
  'bookings.error.completeRegistrationServer.hint':
    'GET /profile is complete; POST /bookings/create still returns “Complete registration before booking”. Filling the form again will not fix it.',
  'bookings.error.profileAuth.title': 'Sign in again to book',
  'bookings.error.profileAuth.session':
    'Your session could not be verified. Sign in again from this browser, then retry your booking.',
  'bookings.error.profileAuth.ipMismatch':
    'Your session is tied to a different network address. Turn off VPN if you use one, then sign in again from this browser.',
  'bookings.error.profileAuth.signInAgain': 'Sign in again',
  'bookings.error.roleBlock.title': 'Cannot book with this account',
  'bookings.error.roleBlock.assetOwner':
    'You are signed in as an asset owner. Owners manage listings; they cannot book places as a client.',
  'bookings.error.roleBlock.businessClient':
    'You are signed in as a business client. This account type cannot create bookings in the app.',
  'bookings.error.roleBlock.profileRole':
    'Your Placy profile is not a bookable client account (for example business client or asset owner).',
  'bookings.error.roleBlock.serverRole':
    'You signed in as a private client in this app, but the server assigned your account role_id {roleId}, which cannot create bookings. Private clients need role_id 1 (or 3 for business workers).',
  'bookings.error.roleBlock.jwtClaims': 'Token role claims: {claims}',
  'bookings.error.roleBlock.loginType':
    'This login type cannot create bookings. Sign in as a private client or business worker.',
  'bookings.period.hour.one': '{count} hour',
  'bookings.period.hour.other': '{count} hours',
  'bookings.period.day.one': '{count} day',
  'bookings.period.day.other': '{count} days',
  'bookings.period.week.one': '{count} week',
  'bookings.period.week.other': '{count} weeks',
  'bookings.period.month.one': '{count} month',
  'bookings.period.month.other': '{count} months',
  'bookings.period.year.one': '{count} year',
  'bookings.period.year.other': '{count} years',
  'bookings.addon.available.one': '1 available',
  'bookings.addon.available.upTo': 'Up to {max} available',
  'bookings.addon.onBooking.noneLeft.one': '1 on this booking (none left to add)',
  'bookings.addon.onBooking.noneLeft': '{count} on this booking (none left to add)',
  'bookings.addon.onBooking.more.one': '{reserved} on booking · 1 more available',
  'bookings.addon.onBooking.more': '{reserved} on booking · {more} more available',
  'bookings.list.pendingUpdateOnly': 'Only pending reservations can be updated.',
  'bookings.list.pendingCancelOnly': 'Only pending reservations can be cancelled.',
  'bookings.list.pastUpdateOnly': 'Past bookings cannot be updated.',
  'bookings.list.pastCancelOnly': 'Past bookings cannot be cancelled.',
  'bookings.list.updateAria': 'Update reservation for {name}',
  'bookings.list.updateBlockedAria': 'Cannot update {name} (not pending)',
  'bookings.list.updateBlockedPastAria': 'Cannot update {name} (past booking)',
  'bookings.list.cancelAria': 'Cancel reservation for {name}',
  'bookings.list.cancelBlockedAria': 'Cannot cancel {name} (not pending)',
  'bookings.list.cancelBlockedPastAria': 'Cannot cancel {name} (past booking)',
  'bookings.viewAsset': 'Asset',
  'bookings.viewAssetAria': 'View asset for {name}',
  'bookings.confirmation.title': 'Your reservation was successful',
  'bookings.confirmation.subtitle': 'Scan or present the barcode.',
  'bookings.confirmation.schedule': 'Date & time',
  'bookings.confirmation.peopleLabel': 'Guests',
  'bookings.confirmation.vehicleLabel': 'Vehicle',
  'bookings.confirmation.bookingId': 'Booking ID',
  'bookings.parkingVehicle.title': 'Choose your car',
  'bookings.parkingVehicle.intro':
    'Parking bookings need a registered car. Continue with your primary car, pick another for this booking only, or edit your list.',
  'bookings.parkingVehicle.continuePrimary': 'Continue with primary car',
  'bookings.parkingVehicle.continueSelected': 'Continue with selected car',
  'bookings.parkingVehicle.editList': 'Edit car list',
  'bookings.parkingVehicle.saveCars': 'Save vehicles',
  'bookings.parkingVehicle.backToList': 'Back to car list',
  'bookings.parkingVehicle.cancel': 'Cancel',
  'bookings.parkingVehicle.none': 'Add at least one car to continue.',
  'bookings.parkingVehicle.required': 'Choose a car for this parking booking.',
  'bookings.confirmation.showBarcode': 'Show barcode',
  'bookings.confirmation.hideBarcode': 'Hide barcode',
  'bookings.confirmation.venueLoading': 'Loading venue…',
  'bookings.confirmation.venueUnknown': 'Venue',
  'bookings.confirmation.qrCaption': 'Present this code at check-in',
  'bookings.confirmation.loading': 'Preparing your reservation…',
  'bookings.confirmation.popupBlocked':
    'Your browser blocked the reservation window — details are shown below.',
  'bookings.confirmation.close': 'Close',
  'bookings.calendarExport.groupLabel': 'Add to calendar',
  'bookings.calendarExport.addToGoogle': 'Add to Google Calendar',
  'bookings.calendarExport.downloadIcs': 'Download .ics',
  'bookings.viewConfirmation': 'Confirmation',
  'bookings.viewConfirmationAria': 'View confirmation for {name}',
  'bookings.myBookings': 'My bookings',
  'bookings.cancellationPolicy.title': 'Cancellation policy',
  'bookings.cancellationPolicy.ruleWeek': 'Until a week before — full refund',
  'bookings.cancellationPolicy.ruleDay': 'Until 24 hours before — 50% refund',
  'bookings.cancellationPolicy.ruleLate': 'Less than 24 hours before — no refund',
  'bookings.cancellationPolicy.agreeLabel': 'I have read and agree to the cancellation policy',
  'bookings.cancellationPolicy.continue': 'Continue to payment',
  'bookings.cancellationPolicy.cancel': 'Cancel',
  'gymHealth.title': 'Health declaration',
  'gymHealth.intro':
    'To register for gym activities, complete this one-time health declaration for trainees.',
  'gymHealth.q.gender': '1. What is your gender?',
  'gymHealth.gender.male': 'Male',
  'gymHealth.gender.female': 'Female',
  'gymHealth.gender.other': 'Prefer not to say',
  'gymHealth.q.birthDate': '2. What is your date of birth?',
  'gymHealth.q.heartDisease': 'Has your doctor told you that you have heart disease?',
  'gymHealth.q.chestPainRest': 'Do you feel chest pain while at rest?',
  'gymHealth.q.chestPainDaily':
    'Do you feel chest pain during everyday routine activities?',
  'gymHealth.q.chestPainExercise': 'Do you feel chest pain while exercising?',
  'gymHealth.q.dizziness': 'In the past year, have you lost your balance because of dizziness?',
  'gymHealth.q.consciousness': 'In the past year, have you lost consciousness?',
  'gymHealth.q.asthma':
    'Has a doctor diagnosed you with asthma, and in the last three months have you had shortness of breath or wheezing?',
  'gymHealth.q.familyHeart':
    'Has a first-degree family member died of heart disease?',
  'gymHealth.q.familySuddenDeath':
    'Has a first-degree family member died suddenly at an early age? (before age 55 for a man, before age 65 for a woman)',
  'gymHealth.q.doctorSupervision':
    'In the last five years, has your doctor told you to exercise only under medical supervision?',
  'gymHealth.q.chronicOther':
    'Do you have a chronic condition not mentioned above that may prevent or limit physical activity?',
  'gymHealth.q.pregnancyRisk':
    'For pregnant women: has this pregnancy or any previous pregnancy been defined as high-risk?',
  'gymHealth.q.smoker': 'Do you smoke?',
  'gymHealth.instructionsTitle': 'Instructions',
  'gymHealth.instruction1':
    'If any answer indicates a medical concern, we may ask you for medical clearance from your family doctor.',
  'gymHealth.instruction2':
    'If your health status changes, consult your doctor about continuing physical activity.',
  'gymHealth.declarationTitle': 'Declaration',
  'gymHealth.declarationBody':
    'I declare that I have read and understood the entire medical questionnaire and that the answers in this form are complete and accurate. I declare that I have provided full and correct information about my past and present medical condition according to the questions asked. I understand that one year after signing this health declaration I will need to submit a new declaration. The health benefits of regular physical activity are well established; this questionnaire clarifies when you should consult a doctor and obtain medical clearance before training.',
  'gymHealth.declarationAgree': 'I confirmed the declaration',
  'gymHealth.submit': 'Submit',
  'gymHealth.cancel': 'Cancel',
  'gymHealth.submitError': 'Could not save the health declaration. Please try again.',
  'bookings.payment.title': 'Payment',
  'bookings.payment.subtitle': 'Choose how to pay and complete your reservation.',
  'bookings.payment.methodLegend': 'Payment method',
  'bookings.payment.methodCard': 'Card',
  'bookings.payment.methodBit': 'Bit',
  'bookings.payment.methodPaypal': 'PayPal',
  'bookings.payment.subtitleCard': 'Enter your card details to complete the reservation.',
  'bookings.payment.subtitleCardPayplus':
    'Card payment continues on the secure PayPlus page — no card details are entered here.',
  'bookings.payment.subtitleBit': 'Pay with Bit using your mobile number.',
  'bookings.payment.subtitlePaypal': 'Pay with your PayPal account.',
  'bookings.payment.amountDue': 'Amount due',
  'bookings.payment.vatIncluded': 'Includes 18% VAT',
  'bookings.payment.cardName': 'Cardholder name',
  'bookings.payment.cardNamePlaceholder': 'Name on card',
  'bookings.payment.cardNumber': 'Card number',
  'bookings.payment.expiry': 'Expiry (MM/YY)',
  'bookings.payment.cvc': 'CVC',
  'bookings.payment.pay': 'Pay {amount}',
  'bookings.payment.payNoAmount': 'Pay',
  'bookings.payment.cancel': 'Cancel',
  'bookings.payment.processing': 'Processing…',
  'bookings.payment.secureNote':
    'You will complete payment securely on PayPlus after tapping Pay.',
  'bookings.payplus.processingTitle': 'Confirming payment…',
  'bookings.payplus.processingBody':
    'We are waiting for PayPlus to confirm your payment. This usually takes a few seconds.',
  'bookings.payplus.processingHint': 'You can leave this screen open — we will refresh automatically.',
  'bookings.payplus.confirmedTitle': 'Payment confirmed',
  'bookings.payplus.confirmedBody': 'Your booking is confirmed. Thank you!',
  'bookings.payplus.failedTitle': 'Payment failed',
  'bookings.payplus.failedBody':
    'PayPlus could not complete the charge. Your booking is still pending — you can try paying again from My Bookings.',
  'bookings.payplus.cancelledTitle': 'Payment cancelled',
  'bookings.payplus.cancelledBody':
    'You left the payment page. Your booking is still pending until you complete payment.',
  'bookings.payplus.backToBookings': 'Back to My Bookings',
  'bookings.payplus.keepWaiting': 'Keep waiting',
  'bookings.payplus.awaitingTitle': 'Payment required',
  'bookings.payplus.awaitingBody':
    'This reservation is pending until payment succeeds. Complete PayPlus checkout to confirm it.',
  'bookings.payplus.payNow': 'Pay with PayPlus',
  'bookings.payplus.testChargeNotice':
    'PayPlus test card detected — this booking will charge ₪1 only (sandbox limit ≤ ₪5).',
  'bookings.payplus.redirectError': 'Could not start PayPlus checkout. Try again.',
  'bookings.payment.savedCardsLegend': 'Cards on file',
  'bookings.payment.useNewCard': 'Use a different card',
  'bookings.payment.usingSavedCard': 'Paying with •••• {last4} ({name})',
  'bookings.payment.errorName': 'Enter the cardholder name.',
  'bookings.payment.errorNameInvalid': 'Enter a valid name (at least 2 letters).',
  'bookings.payment.errorNumber': 'Enter a valid card number (13–19 digits).',
  'bookings.payment.errorNumberLuhn': 'Enter a valid credit card number.',
  'bookings.payment.errorExpiry': 'Enter a valid expiry date (MM/YY).',
  'bookings.payment.errorExpiryPast': 'The card expiry date has passed.',
  'bookings.payment.errorCvc': 'Enter a valid CVC.',
  'bookings.payment.errorBookingFailed':
    'Payment was accepted but the reservation could not be created. Please try again.',
  'bookings.payment.nationalId': 'National ID',
  'bookings.payment.nationalIdPlaceholder': '9-digit ID number',
  'bookings.payment.errorNationalId': 'Enter a valid 9-digit ID number.',
  'bookings.payment.bitPhone': 'Mobile number',
  'bookings.payment.bitPhonePlaceholder': '05X-XXXXXXX',
  'bookings.payment.errorBitPhone': 'Enter a valid Israeli mobile number.',
  'bookings.payment.paypalEmail': 'PayPal email',
  'bookings.payment.paypalEmailPlaceholder': 'you@email.com',
  'bookings.payment.errorPaypalEmail': 'Enter a valid email address.',

  'bookings.workerCredits.title': 'Pay with employer credits',
  'bookings.workerCredits.subtitle':
    'Use the credits your employer allocated. Enter your ID number and your employer’s business ID (ח.פ.).',
  'bookings.workerCredits.nationalId': 'Your ID number',
  'bookings.workerCredits.businessId': 'Employer business ID (ח.פ.)',
  'bookings.workerCredits.businessIdPlaceholder': 'Company registration number',
  'bookings.workerCredits.pay': 'Pay with credits {amount}',
  'bookings.workerCredits.payNoAmount': 'Pay with credits',
  'bookings.workerCredits.openRegularPayment': 'Pay with card, Bit, or PayPal instead',
  'bookings.workerCredits.otpSoon': 'SMS verification will be added here in a future update.',
  'bookings.workerCredits.errorNationalId': 'Enter a valid 9-digit ID number.',
  'bookings.workerCredits.errorBusinessId': 'Enter a valid employer business ID (ח.פ.).',
  'bookings.walletCredits.pay': 'Pay with wallet credits {amount}',
  'bookings.walletCredits.payNoAmount': 'Pay with wallet credits',
  'bookings.walletCredits.method': 'Wallet',
  'bookings.walletCredits.subtitle': 'Pay this booking from your credit wallet balance.',
  'bookings.walletCredits.balance': 'Wallet balance: {amount}',
  'bookings.walletCredits.hint': 'Credits will be deducted when the booking is created.',
  'bookings.walletCredits.secureNote': 'Uses your Placy wallet balance (ceil of the amount due).',

  'profile.title': 'Profile',
  'profile.completion.title': 'Complete your profile to book',
  'profile.completion.intro':
    'Highlighted details are missing or still using signup placeholders. Update those values to continue booking.',
  'profile.completion.loading': 'Loading your profile…',
  'profile.completion.success': 'Profile updated — you can continue with your booking.',
  'profile.completion.saveFailed':
    'Could not save your profile to the server. Check your connection and try again.',
  'profile.completion.successLocalOnly':
    'Your details are saved on this device. The server could not update your email or phone (already registered) — you can continue with your booking.',
  'profile.completion.successPartial':
    'Profile updated. Some contact details could not be changed on the server — you can continue with your booking.',
  'profile.completion.serverStillIncomplete':
    'The server still has incomplete registration details. Choose your country, confirm the terms, and try again.',
  'profile.completion.submit': 'Complete profile',
  'profile.hub.nameLabel': 'Name',
  'profile.hub.settings': 'Settings',
  'profile.hub.userProfile': 'User profile',
  'profile.hub.payment': 'Payment',
  'profile.hub.terms': 'Terms & Conditions',
  'profile.hub.termsClientHeading': 'Terms & Conditions',
  'profile.hub.termsContactPrefix': 'Questions? Email',
  'profile.hub.termsViewOnWeb': 'View full terms on offizz.ai',
  'platform.termsAgree': 'I agree to the terms and conditions',
  'platform.termsAgreeTermsOfUse': 'I agree to the Terms of Use',
  'platform.termsAgreePrivacyPolicy': 'I agree to the Privacy Policy',
  'platform.termsAgreeAccessibility': 'I agree to the Accessibility Statement',
  'platform.termsRequired': 'You must agree to the terms and conditions before continuing.',
  'platform.termsRequiredAll':
    'You must agree to the Terms of Use, Privacy Policy, and Accessibility Statement before continuing.',
  'profile.hub.contact': 'Contact Us',
  'profile.hub.contactGmail': 'Open in Gmail',
  'profile.hub.contactCopyEmail': 'Copy email',
  'profile.hub.contactCopied': 'Copied',
  'profile.hub.language': 'Language',
  'profile.hub.followUs': 'Follow Us',
  'profile.hub.logout': 'Logout',
  'profile.hub.eraseAccount': 'Delete account',
  'profile.hub.deleteAccountSummary':
    'Your account is deactivated immediately and permanently deleted within 30 days: profile, login, favorites, history, saved cards, and messages not related to a booking. Booking, invoice, and payment records (with the name and contact details on them) are kept for 7 years for tax and disputes. Upcoming bookings must be cancelled or completed first.',
  'profile.hub.deleteAccountDetails': 'Full details: what is deleted and what is kept',
  'profile.hub.deleteAccountButton': 'Delete my account',
  'profile.hub.paymentSoon': 'Payment settings will be available here soon.',
  'profile.hub.paymentNotSet': 'No bank account on file yet.',
  'profile.hub.paymentUpdated': 'Payment details saved.',
  'profile.hub.detailsUpdated': 'Your details were saved.',
  'profile.hub.notImplemented': 'This section is not available yet.',
  'profile.hub.eraseConfirm':
    'Delete your PLACY account? You will be signed out now and your account will be permanently deleted within 30 days. Booking and payment records are kept for 7 years as required by law. To cancel the request within 30 days, email info@offizz.ai.',
  'profile.hub.back': 'Back to profile',
  'profile.hub.shieldAria': 'Account security',
  'profile.hub.editProfile': 'Edit profile',
  'profile.hub.editVehicles': 'Edit vehicles',
  'profile.hub.editPayment': 'Edit payment details',
  'profile.hub.detailsTitle': 'Your Details',
  'profile.hub.paymentMethods': 'Payment Methods',
  'profile.hub.editPaymentMethods': 'Edit payment methods',
  'profile.hub.paymentMethodsUpdated': 'Payment method saved.',
  'profile.paymentMethods.notSet': 'No credit card on file yet.',
  'profile.paymentMethods.cardIntro': 'Add up to 3 credit cards for bookings.',
  'profile.paymentMethods.onFile': 'Card on file: {last4}',
  'profile.paymentMethods.empty': 'No cards added yet.',
  'profile.paymentMethods.add': 'Add card',
  'profile.paymentMethods.saveCard': 'Save card',
  'profile.paymentMethods.remove': 'Remove',
  'profile.paymentMethods.primary': 'Primary',
  'profile.paymentMethods.setPrimary': 'Set as primary',
  'profile.paymentMethods.maxReached': 'You can save up to 3 cards.',
  'profile.paymentMethods.errorMax': 'You can add up to 3 cards.',
  'profile.paymentMethods.errorDuplicate': 'That card is already on file.',
  'profile.paymentMethods.secureNote':
    "Disclaimer: All card details you enter are kept only on this device. They are not stored on the company's servers.",
  'profile.hub.buildInfoAria': 'App version and environment',
  'profile.hub.profileLastUpdated': 'Last updated {date}',
  'profile.hub.profileLastUpdatedUnknown': 'Last updated: not recorded yet',
  'profile.hub.buildInfoEnvironment': 'Environment',
  'profile.hub.buildInfoUpdated': 'Last update',
  'profile.hub.buildInfoVersion': 'Version',
  'profile.hub.buildInfoPlayVersion': 'Google Play',
  'profile.hub.buildInfoUnknown': 'Unknown',
  'profile.hub.employerManaged': 'Employer-managed',
  'profile.hub.workerProfileReadOnly':
    'Your employer manages your name, phone, and other profile details. You can update your profile photo using the camera on your avatar above.',
  'profile.hub.workerPhotoReadOnly':
    'Profile photo is managed by your employer. Contact your manager to change it.',
  'profile.hub.workerPhotoUpdated': 'Profile photo updated.',
  'profile.hub.workerPhotoUploadFailed':
    'Could not save your photo. The server may still block worker profile updates — your platform admin needs to allow PATCH /profile with profile_image for business workers (role_id 3).',
  'profile.hub.photoUploadFailed': 'Could not upload your profile photo. It is saved on this device only for now.',
  'profile.hub.accountType': 'Account type',
  'profile.hub.serverRoleId': 'Server role (role_id)',
  'profile.field.firstName': 'First name',
  'profile.field.lastName': 'Last name',
  'profile.field.cellPhone': 'Cell phone',
  'profile.field.email': 'E-mail',
  'profile.field.dateOfBirth': 'Date of birth',
  'profile.field.occupation': 'Occupation',
  'profile.field.ownerLogo': 'Business logo',
  'profile.field.employeeRegistrationCode': 'Employee registration code',
  'profile.field.workerRegistrationCode': 'Employee registration code',
  'profile.field.availableCredits': 'Available credits',
  'profile.field.availableCreditsHint':
    'This balance comes from your employer (credits per employee) and cannot be changed here.',
  'profile.hub.walletCredits': '{amount} credits',
  'profile.hub.walletCreditsAria': 'Available credits: {amount}',
  'profile.hub.myWallet': 'My Wallet',
  'profile.hub.loadCredits': 'Load credits',
  'profile.hub.loadCreditsWalletBtn': 'Load\ncredits',
  'profile.hub.loadCreditsButton': 'Load',
  'profile.hub.loadCreditsTitle': 'Load credits',
  'profile.hub.loadCreditsIntro': 'Choose a credit pack or enter a custom amount, then pay to add credits to your wallet.',
  'profile.hub.loadCreditsBalance': 'Current balance: {amount}',
  'profile.hub.loadCreditsChoose': 'Select a pack',
  'profile.hub.loadCreditsPackCredits': '{count} credits',
  'profile.hub.loadCreditsCustom': 'Custom amount',
  'profile.hub.loadCreditsCustomAmount': 'Enter amount',
  'profile.hub.loadCreditsCustomPlaceholder': 'e.g. 750',
  'profile.hub.loadCreditsCustomInvalid': 'Enter a valid amount of at least ₪1.',
  'profile.hub.loadCreditsContinue': 'Continue to payment',
  'profile.field.notSet': 'Not set',
  'profile.vehicles.title': 'Vehicles',
  'profile.vehicles.optionalHint': 'Optional — add up to 3 vehicles. One must be primary.',
  'profile.vehicles.empty': 'No vehicles added yet.',
  'profile.vehicles.noneOnFile': 'No vehicles on file.',
  'profile.vehicles.add': 'Add vehicle',
  'profile.vehicles.remove': 'Remove',
  'profile.vehicles.carN': 'Vehicle {n}',
  'profile.vehicles.manufacturer': 'Manufacturer',
  'profile.vehicles.model': 'Model',
  'profile.vehicles.color': 'Color',
  'profile.vehicles.licenseNumber': 'License number',
  'profile.vehicles.licensePlaceholder': 'Digits only',
  'profile.vehicles.primary': 'Primary',
  'profile.vehicles.setPrimary': 'Primary vehicle',
  'profile.vehicles.maxReached': 'You can save up to 3 vehicles.',
  'profile.vehicles.errorMax': 'You can add up to 3 vehicles.',
  'profile.vehicles.errorIncomplete': 'Fill manufacturer, model, color, and license number for each vehicle.',
  'profile.vehicles.errorLicense': 'License number must be 5–8 digits (Israel).',
  'profile.vehicles.errorDuplicateLicense': 'Each vehicle needs a unique license number.',
  'profile.vehicles.errorPrimary': 'Choose one primary vehicle.',
  'profile.edit.save': 'Save changes',
  'profile.hub.changePhoto': 'Change profile photo',
  'profile.hub.changePhotoAria': 'Add or change profile photo',
  'profile.hub.cropTitle': 'Crop profile photo',
  'profile.hub.cropZoom': 'Zoom',
  'profile.hub.cropSave': 'Use photo',
  'profile.hub.cropCancel': 'Cancel',
  'profile.apiLabel': 'Profile API',
  'profile.signInToUse': 'Sign in to use profile tools.',
  'profile.operation.getProfile': 'Get my profile',
  'profile.operation.listWorkers': 'List workers',
  'profile.operation.registerWorker': 'Register business worker',
  'profile.operation.patchProfile': 'Update Profile',
  'profile.operation.changePassword': 'Change password',
  'profile.operation.deactivate': 'Deactivate account',
  'profile.failureRegion': 'Why this profile request failed',
  'profile.signedInAs': 'Signed in as {name}',
  'profile.signedInAsWithType': 'Signed in as {name} · {type}',
  'profile.signInBanner': 'Sign in to use profile.',
  'profile.operationLabel': 'Operation',
  'profile.oldPassword': 'Old password',
  'profile.currentPassword': 'Current password',
  'profile.newPassword': 'New password',
  'profile.confirmNewPassword': 'Confirm new password',
  'profile.passwordMismatch': 'Must match the new password above.',
  'profile.passwordChangeOptional': 'Optional — leave blank to keep your current password.',
  'profile.passwordAllFieldsRequired': 'Enter current, new, and confirmation password.',
  'profile.signInToRun': 'Sign in to run profile operations.',
  'profile.businessClientWorkers': 'Sign in as a business client to register workers.',
  'profile.businessWorkers.title': 'Business workers',
  'profile.businessWorkers.listIntro':
    'Workers linked to your business account. Tap a worker to view details and manage credits.',
  'profile.businessWorkers.empty': 'No active workers yet.',
  'profile.businessWorkers.backToList': 'Back to workers',
  'profile.businessWorkers.creditsShort': '{amount} credits',
  'profile.businessWorkers.editCredits': 'Edit available credits',
  'profile.businessWorkers.editCreditsTitle': 'Employer credits',
  'profile.businessWorkers.updateCredits': 'Update worker credits',
  'profile.businessWorkers.creditsUpdated': 'Worker credits updated.',
  'profile.businessWorkers.errorInvalidCredits': 'Enter a valid credit amount (0 or higher).',
  'profile.businessWorkers.changePhoto': 'Change worker photo',
  'profile.businessWorkers.changePhotoAria': 'Add or change worker profile photo',
  'profile.businessWorkers.updatePhoto': 'Update worker photo',
  'profile.businessWorkers.photoUpdated': 'Worker photo updated.',
  'profile.showWorkers': 'Show workers',
  'profile.workersActiveOnly': 'Active only',
  'profile.workersAll': 'All workers',
  'profile.response': 'Response',
  'profile.whyFailed': 'Why this failed',
  'profile.details': 'Details',
  'profile.defaultTitle': 'Profile',
  'profile.emptyResponse': 'Empty response.',
  'profile.noWorkers': 'No workers match this view.',
  'profile.updateWorker': 'Update worker',
  'profile.rawJson': 'Raw JSON',
  'profile.submit.saveProfile': 'Save profile',
  'profile.worker.updated': 'Worker updated.',
  'profile.worker.deactivated': 'Worker deactivated.',
  'profile.worker.reactivated': 'Worker reactivated.',
  'profile.worker.saving': 'Saving…',
  'profile.worker.reactivating': 'Reactivating…',
  'profile.worker.deactivating': 'Deactivating…',
  'profile.worker.reactivate': 'Reactivate',
  'profile.worker.deactivate': 'Deactivate',
  'profile.status.active': 'Active',
  'profile.status.inactive': 'Inactive',
  'profile.gender.male': 'Male',
  'profile.gender.female': 'Female',
  'profile.gender.other': 'Other',
  'profile.gender.select': 'Select gender…',

  'assetField.id': 'ID',
  'assetField.assetId': 'Asset ID',
  'assetField.assetName': 'Asset name',
  'assetField.name': 'Name',
  'assetField.facilityName': 'Facility name',
  'assetField.description': 'Description',
  'assetField.subTitle': 'Subtitle',
  'assetField.email': 'Email',
  'assetField.phoneNumber': 'Phone number',
  'assetField.phoneNumber2': 'Second phone number',
  'assetField.phone': 'Phone',
  'assetField.registrationDate': 'Registration date',
  'assetField.registeredAt': 'Registered at',
  'assetField.createdAt': 'Created at',
  'assetField.updatedAt': 'Updated at',
  'assetField.deletedAt': 'Deleted at',
  'assetField.stateId': 'Region',
  'assetField.countryId': 'Country',
  'assetField.regionId': 'Region',
  'assetField.districtId': 'District',
  'assetField.assetTypeId': 'Asset type',
  'assetField.assetTypeName': 'Asset type',
  'assetField.assetStatus': 'Asset status',
  'assetField.avgRating': 'Average rating',
  'assetField.averageRating': 'Average rating',
  'assetField.reviewsCount': 'Reviews count',
  'assetField.reviewCount': 'Review count',
  'assetField.countryName': 'Country',
  'assetField.stateName': 'State / district',
  'assetField.regionName': 'Region',
  'assetField.districtName': 'District',
  'assetField.pricingTypeName': 'Pricing type',
  'assetField.facilityTypeName': 'Facility type',
  'assetField.typeName': 'Type',
  'assetField.latitude': 'Latitude',
  'assetField.longitude': 'Longitude',
  'assetField.minCapacity': 'Minimum capacity',
  'assetField.maxCapacity': 'Maximum capacity',
  'assetField.capacity': 'Capacity',
  'assetField.street': 'Street',
  'assetField.streetNumber': 'Street number',
  'assetField.houseNumber': 'House number',
  'assetField.city': 'City',
  'assetField.zipCode': 'ZIP code',
  'assetField.postalCode': 'Postal code',
  'assetField.zip': 'ZIP',
  'assetField.state': 'State',
  'assetField.country': 'Country',
  'assetField.address': 'Address',
  'assetField.addressLine1': 'Address line 1',
  'assetField.addressLine2': 'Address line 2',
  'assetField.addressAdditional': 'Additional info',
  'assetField.isVerifiedPhone': 'Phone verified',
  'assetField.isVerifiedEmail': 'Email verified',
  'assetField.building': 'Building',
  'assetField.floor': 'Floor',
  'assetField.apartment': 'Apartment',
  'assetField.price': 'Price',
  'assetField.unitPrice': 'Unit price',
  'assetField.amount': 'Amount',
  'assetField.cost': 'Cost',
  'assetField.rate': 'Rate',
  'assetField.fee': 'Fee',
  'assetField.addonPrice': 'Add-on price',
  'assetField.availableQuantity': 'Available quantity',
  'assetField.quantity': 'Quantity',
  'assetField.pricingTypeId': 'Pricing type',
  'assetField.pricingType': 'Pricing type',
  'assetField.facilityId': 'Facility',
  'assetField.addonId': 'Add-on',
  'assetField.facilityTypeId': 'Facility type',
  'assetField.addonName': 'Add-on name',
  'assetField.title': 'Title',
  'assetField.label': 'Label',
  'assetField.status': 'Status',
  'assetField.active': 'Active',
  'assetField.published': 'Published',
  'assetField.ownerId': 'Owner',
  'assetField.userId': 'User',
  'assetField.workerId': 'Worker ID',
  'assetField.firstName': 'First name',
  'assetField.lastName': 'Last name',
  'assetField.businessName': 'Business name',
  'assetField.businessType': 'Business type',
  'assetField.isBusiness': 'Is business',
  'assetField.businessId': 'Business ID',
  'assetField.creditsPerEmployee': 'Credits per employee',
  'assetField.credits': 'Credits',
  'assetField.nationalId': 'National ID',
  'assetField.birthDate': 'Date of birth',
  'assetField.gender': 'Gender',
  'assetField.position': 'Position',
  'assetField.roleId': 'Role',
  'assetField.isActive': 'Active',
  'assetField.workerStatus': 'Worker status',
  'assetField.employmentStatus': 'Employment status',
  'assetField.password': 'Password',
  'assetField.confirmPassword': 'Confirm password',
  'assetField.oldPassword': 'Old password',
  'assetField.newPassword': 'New password',
  'assetField.images': 'Images',
  'assetField.openingTimes': 'Opening times',
  'assetField.facilities': 'Facilities',
  'assetField.pricingMethods': 'Pricing methods',
  'assetField.addons': 'Add-ons',
  'assetField.currency': 'Currency',
  'assetField.vat': 'VAT',
  'assetField.tax': 'Tax',
  'assetField.notes': 'Notes',
  'assetField.website': 'Website',
  'assetField.url': 'URL',

  'weekday.sunday': 'Sunday',
  'weekday.monday': 'Monday',
  'weekday.tuesday': 'Tuesday',
  'weekday.wednesday': 'Wednesday',
  'weekday.thursday': 'Thursday',
  'weekday.friday': 'Friday',
  'weekday.saturday': 'Saturday',

  'openingTimes.weekdaysSection': 'Weekdays',
  'openingTimes.fridaySection': 'Friday',
  'openingTimes.saturdaySection': 'Saturday',
  'openingTimes.sundaySection': 'Sunday',
  'openingTimes.weekendSection': 'Weekend',
  'openingTimes.setOpenHours': 'Set open hours',
  'openingTimes.open': 'Open',
  'openingTimes.close': 'Close',
  'openingTimes.openAllDay': 'Open all day',
  'openingTimes.setClosed': 'Set closed',
  'openingTimes.allDayHint': 'Sent as full day ({open}–{close}).',
  'openingTimes.specificDates': 'Specific dates',
  'openingTimes.hideList': 'Hide list',
  'openingTimes.showList': 'Show list ({count})',
  'openingTimes.specificDatesHint': 'Pick today or a future date (day, month, year).',
  'openingTimes.addSpecificDate': 'Add specific date',
  'openingTimes.noSpecialDatesYet': 'No specific dates yet.',
  'openingTimes.selectSpecificDate': 'Select a date…',
  'openingTimes.blackoutDates': 'Blackout dates',
  'openingTimes.blackoutDatesHint':
    'Choose a start date, then set either the number of days or an end date. The other field updates automatically.',
  'openingTimes.blackoutStart': 'Start date',
  'openingTimes.blackoutDays': 'Number of days',
  'openingTimes.blackoutEnd': 'End date',
  'openingTimes.addBlackoutDates': 'Add blackout dates',
  'openingTimes.noBlackoutDatesYet': 'No blackout dates yet.',
  'openingTimes.blackoutRangesListHint': 'Saved blackout ranges. Expand a range to change dates or remove it.',
  'openingTimes.blackoutRangeDays': '{n} days',
  'openingTimes.saveBlackoutRange': 'Save range',
  'openingTimes.removeBlackoutRange': 'Remove range',
  'openingTimes.blackoutPickStart': 'Choose a start date first.',
  'openingTimes.blackoutInvalidRange': 'End date must be on or after the start date.',
  'openingTimes.remove': 'Remove',
  'openingTimes.dayOverrides': 'Different hours by day',
  'openingTimes.removeDayOverride': 'Use group hours',
  'openingTimes.addDay': 'Add day',
  'openingTimes.addDayHint':
    'Use this when one weekday needs different hours than the shared weekday schedule above.',
  'openingTimes.customizeDaysMenu': 'Customize one weekday',
  'openingTimes.expandAllWeekdays': 'Set each weekday separately',
  'openingTimes.selectDay': 'Select day…',
  'openingTimes.pickDateFirst': 'Choose day, month, and year first.',
  'openingTimes.pickDateThenAdd': 'Pick day, month, and year, then tap Add.',
  'openingTimes.dateMustBeFuture': 'Choose today or a future date.',
  'openingTimes.dateAlreadyExists': '“{date}” is already in opening times.',

  'assetDetail.asset': 'Asset',
  'assetDetail.address': 'Address',
  'assetDetail.openingTimes': 'Opening times',
  'assetDetail.daysOfWeek': 'Days of the week',
  'assetDetail.dateOverrides': 'Date overrides',
  'assetDetail.day': 'Day',
  'assetDetail.allDays': 'All days',
  'assetDetail.hours': 'Hours',
  'assetDetail.closed': 'Closed',
  'assetDetail.open24h': 'Open 24 hours',
  'assetDetail.description': 'Description',
  'assetDetail.details': 'Details',
  'assetDetail.capacity': 'Capacity',
  'assetDetail.facilitiesAddons': 'Facilities',
  'assetDetail.pricing': 'Pricing',
  'assetDetail.images': 'Images',
  'assetDetail.assetImages': 'Asset images',
  'assetDetail.imageNotAvailable': 'Image not available',
  'assetDetail.type': 'Type',
  'assetDetail.item': 'Item',
  'assetDetail.facility': 'Facility',
  'assetDetail.addon': 'Add-on',
  'assetDetail.imagesWireError':
    'This asset includes an images field, but no usable URL or path could be read from those entries. Each item should be a string path/URL or an object with url, src, image_url, or path. If uploads are stored only on disk, the API must expose a URL or web path.',
  'assetDetail.specificDates': 'Specific dates ({count})',
  'assetDetail.imageNumber': 'Image {index}',
  'assetDetail.viewLarger': 'View larger image',
  'assetDetail.closeLightbox': 'Close',

  'assetProfile.about': 'About this asset',
  'assetProfile.listingInfo': 'Listing details',
  'assetProfile.listingDate': 'Listing date',
  'assetProfile.ratingAndReviews': 'Rating & reviews',
  'assetProfile.ratingSummary': '{rating} · {count} reviews',
  'assetProfile.noReviewsYet': 'No reviews yet',
  'assetProfile.reviews': 'Reviews',
  'assetProfile.reviewsRecent': 'Recent',
  'assetProfile.reviewsAll': 'All',
  'assetProfile.reviewsChoice': 'Choice reviews',
  'assetProfile.reviewsComingSoon': 'Reviews will appear here soon.',
  'assetProfile.pricingHourly': 'Hourly',
  'assetProfile.pricingDaily': 'Daily',
  'assetProfile.pricingMonthly': 'Monthly',
  'assetProfile.pricesExcludeVat': "The prices don't include relevant taxes",
  'assetProfile.priceNotSet': 'Not set',
  'assetProfile.share': 'Share',
  'assetProfile.call': 'Call',
  'assetProfile.whatsapp': 'WhatsApp',
  'assetProfile.email': 'Email',
  'assetProfile.emailGmail': 'Gmail',
  'assetProfile.emailApp': 'Default mail app',
  'assetProfile.navigate': 'Navigate',
  'assetProfile.distance': '{distance} away',
  'assetProfile.totalFrom': 'From {price}',
  'assetProfile.carouselPrev': 'Previous image',
  'assetProfile.carouselNext': 'Next image',

  'quickBooking.title': 'Booking',
  'quickBooking.modeLabel': 'Booking type',
  'quickBooking.modeHour': 'Hourly',
  'quickBooking.modeDay': 'Daily',
  'quickBooking.modeMonth': 'Monthly',
  'quickBooking.selectDate': 'Select date',
  'quickBooking.dayColumn': 'Day',
  'quickBooking.monthColumn': 'Month',
  'quickBooking.yearColumn': 'Year',
  'quickBooking.openCalendar': 'Open calendar',
  'quickBooking.entryTime': 'Entry time',
  'quickBooking.exitTime': 'Exit time',
  'quickBooking.totalHours': 'Total hours',
  'quickBooking.totalDays': 'Number of days',
  'quickBooking.totalMonths': 'Number of months',
  'quickBooking.people': 'Number of people',
  'quickBooking.peopleAvailable': 'Available for these dates: {capacity}',
  'quickBooking.totalToPay': 'Total to pay:',
  'quickBooking.pricePending': '—',
  'quickBooking.proceedToPayment': 'Proceed to payment',
  'quickBooking.errorHours': 'Choose a valid time range (whole hours only).',
  'quickBooking.errorClosedHours': 'The asset is closed during part of the selected hours.',
  'quickBooking.errorClosedDay': 'The asset is closed on one or more selected days.',
  'quickBooking.errorClosedMonth': 'The asset is closed on one or more days in the selected months.',
  'quickBooking.errorFullyBooked': 'No booking slots are available on the selected date.',

  'list.listedAssets': 'Listed assets',
  'list.assetType': 'Asset type',
  'list.view': 'View',
  'list.viewAsset': 'View {title}',
  'list.edit': 'Edit',
  'list.editAsset': 'Edit {title}',
  'list.cannotEditNoId': 'Cannot edit {title} (missing id)',
  'list.cannotEditNotOwner': 'Cannot edit {title} (not your asset)',
  'list.ownerOnlyEdit': 'Only the listed owner can edit this asset.',
  'list.distanceAria': 'Distance from your location: {distance}',
  'list.book': 'Book',
  'list.cannotBookSignIn': 'Cannot book {title} (sign in required)',
  'list.cannotBookNoId': 'Cannot book {title} (missing id)',
  'list.bookAsset': 'Book {title}',
  'list.cannotDeleteNoId': 'Cannot delete {title} (missing id)',
  'list.cannotDeleteNotOwner': 'Cannot delete {title} (not your asset)',
  'list.deleteAsset': 'Delete {title}',
  'list.ownerOnlyDelete': 'Only the listed owner can delete this asset.',
  'list.imagesNotice':
    'Images field present but paths could not be read — check API shape or URLs.',

  'connection.title': 'Connection test',
  'connection.runCheck': 'Run connection check',
  'connection.checking': 'Checking…',
  'connection.tokenStatus': 'API Bearer token status',
  'connection.apiTest': 'API connection test',
  'connection.notificationsTest': 'Notifications — test connection',

  'form.closed': 'Closed',
  'form.openingDate': 'Specific date for opening hours',
  'form.notOnPatch': 'Not applied on PATCH for this endpoint',
  'form.notSentPatch': 'Not sent with PATCH — field omitted or ignored by this endpoint',
  'form.notSentPatchNested': 'Not sent with PATCH — omit or nested display-only payload',
} as const;

export type MessageKey = keyof typeof en;
